/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ClaimId: { input: any; output: any; }
  /** Date, given as an ISO 8601 string. Parsed as UTC if time offset is not given. */
  Date: { input: any; output: any; }
  DeviceId: { input: any; output: any; }
  /**
   * Global location number, used world wide to identify legal, physical and
   * functional locations. These are used as identifiers e.g. companies and power
   * meter ids.
   */
  Gln: { input: any; output: any; }
  IntermediaryId: { input: any; output: any; }
  JSON: { input: any; output: any; }
  MeterId: { input: any; output: any; }
  /** Nothing */
  Void: { input: any; output: any; }
};

export type Activation = {
  __typename?: 'Activation';
  status: ActivationStatus;
  updatedAt: Scalars['Date']['output'];
};

export enum ActivationStatus {
  Activated = 'ACTIVATED',
  Deactivated = 'DEACTIVATED'
}

export type ActiveEnergyImportedRecord = {
  __typename?: 'ActiveEnergyImportedRecord';
  startTime: Scalars['Date']['output'];
  wh: Scalars['Int']['output'];
};

export type ActiveEnergyImportedRecordInput = {
  startTime: Scalars['Date']['input'];
  wh: Scalars['Int']['input'];
};

export type AddBrightNotificationChannelToAlertSettingInput = {
  alertSettingId: Scalars['ID']['input'];
};

export type AddBrightNotificationChanneltToAlertSettingPayload = {
  __typename?: 'AddBrightNotificationChanneltToAlertSettingPayload';
  notificationChannel: BrightNotificationChannel;
};

export type AddChargingLocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  name: Scalars['String']['input'];
};

export type AddChargingLocationPayload = AddChargingLocationSuccessPayload | ChargingLocationAlreadyExistsPayload;

export enum AddChargingLocationResponseType {
  AlreadyExists = 'ALREADY_EXISTS',
  Success = 'SUCCESS'
}

export type AddChargingLocationSuccessPayload = {
  __typename?: 'AddChargingLocationSuccessPayload';
  chargingLocation: ChargingLocation;
  type: AddChargingLocationResponseType;
};

export type AddChargingPermissionInput = {
  userIdentifier: UserIdentifierInput;
};

export type AddChargingPermissionPayload = {
  __typename?: 'AddChargingPermissionPayload';
  modifiedPermission: Permission;
  success: Scalars['Boolean']['output'];
  user: UserInfo;
};

export type AddControllableForLocationInput = {
  controllableId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};

export type AddControllableForLocationPayload = {
  __typename?: 'AddControllableForLocationPayload';
  location: Location;
};

export type AddDevicePermissionsInput = {
  deviceIdentifiers: Array<DeviceIdentifierInput>;
  userIdentifier: UserIdentifierInput;
};

export type AddDevicePermissionsPayload = {
  __typename?: 'AddDevicePermissionsPayload';
  modifiedPermissions: Array<Permission>;
  success: Scalars['Boolean']['output'];
  user: UserInfo;
};

export type AddEstimatedHourlyActiveEnergyLimitWarningAlertSettingInput = {
  deviceId: Scalars['String']['input'];
  limitInWattHours: Scalars['Int']['input'];
};

export type AddHourlyConsumptionLimitEstimationWarningAlertSettingInput = {
  deviceId: Scalars['String']['input'];
  limitInWatts: Scalars['Int']['input'];
};

export type AddIntermediaryApiKeyInput = {
  /** The name of the api key. This is to easier keep track of keys. */
  name: Scalars['String']['input'];
};

export type AddIntermediaryWebhookNotificationChannelToAlertSettingInput = {
  alertSettingId: Scalars['ID']['input'];
  callbackUrl: Scalars['String']['input'];
  intermediaryId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

export type AddIntermediaryWebhookNotificationChannelToAlertSettingPayload = {
  __typename?: 'AddIntermediaryWebhookNotificationChannelToAlertSettingPayload';
  notificationChannel: IntermediaryWebhookNotificationChannel;
};

export type AddLocationInput = {
  coordinates: LatLngInput;
  name: Scalars['String']['input'];
};

export type AddLocationPayload = {
  __typename?: 'AddLocationPayload';
  location: Location;
};

export type AddPriceWarningAlertSettingInput = {
  energyBiddingZone: EnergyBiddingZone;
};

export type AddPushNotificationChannelToAlertSettingInput = {
  alertSettingId: Scalars['ID']['input'];
};

export type AddPushNotificationChannelToAlertSettingPayload = {
  __typename?: 'AddPushNotificationChannelToAlertSettingPayload';
  notificationChannel: PushNotificationChannel;
};

export type AddUserInput = {
  userIdentifier: UserIdentifierInput;
};

export type AddUserPayload = {
  __typename?: 'AddUserPayload';
  success: Scalars['Boolean']['output'];
  user: UserInfo;
};

export type AddUserSessionInput = {
  userIdentifier: UserIdentifierInput;
};

export type AddUserSessionPayload = {
  __typename?: 'AddUserSessionPayload';
  session: SessionInfo;
  success: Scalars['Boolean']['output'];
  user: UserInfo;
};

export type AddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  countryCode: CountryCode;
  postalCode: Scalars['String']['input'];
};

export enum AlertChannelType {
  BrightNotification = 'BRIGHT_NOTIFICATION',
  IntermediaryWebhook = 'INTERMEDIARY_WEBHOOK',
  PushNotification = 'PUSH_NOTIFICATION'
}

/** Types of alert events. */
export type AlertEvent = EstimatedConsumptionWarningEvent | HourlyConsumptionReachedEvent | HourlyConsumptionWarningEvent | PriceWarningEvent;

export enum AlertEventType {
  EstimatedHourlyActiveEnergyLimitWarning = 'ESTIMATED_HOURLY_ACTIVE_ENERGY_LIMIT_WARNING',
  HourlyConsumptionLimitEstimationWarning = 'HOURLY_CONSUMPTION_LIMIT_ESTIMATION_WARNING',
  HourlyConsumptionReached = 'HOURLY_CONSUMPTION_REACHED',
  PriceWarning = 'PRICE_WARNING'
}

export type AlertEventsOfChannelTypeInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  notificationChannelType: NotificationChannelType;
};

export type AlertEventsOfChannelTypePayload = {
  __typename?: 'AlertEventsOfChannelTypePayload';
  events: Array<AlertEvent>;
};

export type AlertEventsPayload = {
  __typename?: 'AlertEventsPayload';
  events: Array<AlertEvent>;
};

/** An alert setting is a configuration that defines what type, when, or how an alert should be triggered. */
export type AlertSetting = EstimatedHourlyActiveEnergyLimitWarningAlertSetting | HourlyConsumptionLimitEstimationWarningAlertSetting | PriceWarningAlertSetting;

export type AlertSettingCreator = EndUserAlertSettingCreator | IntermediaryAlertSettingCreator;

export enum AlertSettingCreatorType {
  EndUser = 'END_USER',
  Intermediary = 'INTERMEDIARY'
}

export enum AlertType {
  EstimatedHourlyActiveEnergyLimitWarning = 'ESTIMATED_HOURLY_ACTIVE_ENERGY_LIMIT_WARNING',
  HourlyConsumptionLimitEstimationWarning = 'HOURLY_CONSUMPTION_LIMIT_ESTIMATION_WARNING',
  PriceWarning = 'PRICE_WARNING'
}

export type BrightNotificationChannel = {
  __typename?: 'BrightNotificationChannel';
  forUserWithId: Scalars['String']['output'];
  type: NotificationChannelType;
};

export type CancelOrderInput = {
  orderId: Scalars['String']['input'];
};

export type CapacityCost = {
  __typename?: 'CapacityCost';
  capacityStep?: Maybe<CapacityStep>;
  cost: PriceSpecification;
};

export enum CapacityModelBusinessType {
  ConstantBusiness = 'ConstantBusiness',
  FuseAndVoltageSizeBusiness = 'FuseAndVoltageSizeBusiness',
  MonthlyPeaksAtDifferentDaysBusiness = 'MonthlyPeaksAtDifferentDaysBusiness',
  WeightedYearlyRollingPeaksInDifferentWeeksBusiness = 'WeightedYearlyRollingPeaksInDifferentWeeksBusiness'
}

export enum CapacityModelType {
  FuseAndHomeBasedSelectableSeasonal = 'FuseAndHomeBasedSelectableSeasonal',
  FuseAndHomeType = 'FuseAndHomeType',
  FuseAndVoltageSize = 'FuseAndVoltageSize',
  MonthlyPeaksAtDifferentDays = 'MonthlyPeaksAtDifferentDays',
  MonthlyPeaksAtDifferentDaysLinearWithBase = 'MonthlyPeaksAtDifferentDaysLinearWithBase',
  WeightedYearlyRollingPeaksInDifferentWeeks = 'WeightedYearlyRollingPeaksInDifferentWeeks'
}

/** The capacity steps includes as range in Wh and a price for the capacity step */
export type CapacityStep = {
  __typename?: 'CapacityStep';
  capacityStepPrice: PriceSpecification;
  rangeInWh: EnergyRangeInWh;
};

export type ChargeCost = {
  __typename?: 'ChargeCost';
  cost: Scalars['Float']['output'];
  currency?: Maybe<Currency>;
  savings: Scalars['Float']['output'];
};

/**
 * Type ChargeSettings
 * - `id` is the id of the charge settings.
 * - `vehicleId` is the id of the vehicle.
 * - `departureTimes` is a list of departure times for each day of the week.
 * - `desiredBatteryLevel` is the battery level at which the car should be charged at the departure time.
 * - `directChargingBatteryLevel` is the battery level at which the car should start charging immediately.
 * - `enableSmartChargingAt` is the date at which smart charging should be enabled.
 * - `isSmartChargingEnabled` is whether smart charging is enabled.
 * - `isSolarChargingEnabled` is whether solar charging is enabled.
 * - `maxAllowedTargetSoC` is the maximum allowed target state of charge.
 * - `timeZone` is the time zone of the user.
 */
export type ChargeSettings = {
  __typename?: 'ChargeSettings';
  defaultStartBatteryLevel: Scalars['Float']['output'];
  departureTimes: DepartureTimes;
  desiredBatteryLevel: Scalars['Float']['output'];
  directChargingBatteryLevel: Scalars['Float']['output'];
  enableSmartChargingAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  isSmartChargingEnabled: Scalars['Boolean']['output'];
  isSolarChargingEnabled: Scalars['Boolean']['output'];
  maxAllowedTargetSoC: Scalars['Float']['output'];
  timeZone: Timezone;
  vehicleId: Scalars['String']['output'];
};

export type ChargingHistoryEntry = {
  __typename?: 'ChargingHistoryEntry';
  chargedEnergyInKwh: Scalars['Float']['output'];
  endTime: Scalars['Date']['output'];
  startTime: Scalars['Date']['output'];
};

export type ChargingLocation = {
  __typename?: 'ChargingLocation';
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type ChargingLocationAlreadyExistsPayload = {
  __typename?: 'ChargingLocationAlreadyExistsPayload';
  type: AddChargingLocationResponseType;
};

export type ChargingSession = {
  __typename?: 'ChargingSession';
  chargeCost: ChargeCost;
  chargingLocationId: Scalars['String']['output'];
  energy: Array<Maybe<ChargingHistoryEntry>>;
  isSmartSession: Scalars['Boolean']['output'];
  sessionId: Scalars['String']['output'];
};

export type ChargingStatisticsEntry = {
  __typename?: 'ChargingStatisticsEntry';
  costSum: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  estimatedSavings: Scalars['Float']['output'];
  kw: Range;
  kwhSum: Scalars['Float']['output'];
  nonSmartPrice: Range;
  price: Range;
  priceCurrency: Currency;
  smartSession: Scalars['Boolean']['output'];
};

export type ChargingStatisticsInput = {
  chargingLocationId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<ChargingStatisticsResolution>;
  startDate: Scalars['Date']['input'];
  type?: InputMaybe<ChargingStatisticsType>;
  utcOffset?: InputMaybe<Scalars['Float']['input']>;
};

export type ChargingStatisticsPayload = {
  __typename?: 'ChargingStatisticsPayload';
  entries: Array<ChargingStatisticsEntry>;
};

export enum ChargingStatisticsResolution {
  Day = 'DAY',
  HalfHour = 'HALF_HOUR',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export enum ChargingStatisticsType {
  Charger = 'CHARGER',
  Hvac = 'HVAC',
  Vehicle = 'VEHICLE'
}

export type CheckJedlixConnectionInput = {
  connectionId: Scalars['String']['input'];
};

export type CommonSignInInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
  vendor: CommonSignInVendor;
};

export type CommonSignInPayload = {
  __typename?: 'CommonSignInPayload';
  success: Scalars['Boolean']['output'];
};

export enum CommonSignInVendor {
  Mill = 'MILL'
}

export type ConfiguredIntegrationVendorDevice = ConfiguredIntegrationVendorVehicle;

export type ConfiguredIntegrationVendorInfo = {
  __typename?: 'ConfiguredIntegrationVendorInfo';
  devices: Array<ConfiguredIntegrationVendorDevice>;
  status: IntegrationVendorStatus;
  vendor: IntegrationVendor;
};

export type ConfiguredIntegrationVendorVehicle = {
  __typename?: 'ConfiguredIntegrationVendorVehicle';
  chargeState: ConfiguredIntegrationVendorVehicleChargeState;
  chargingLocationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isReachable: Scalars['Boolean']['output'];
  isSmartChargingCapable: Scalars['Boolean']['output'];
  location: ConfiguredIntegrationVendorVehicleLocationState;
  model: Scalars['String']['output'];
  smartChargingPolicy?: Maybe<SmartChargingPolicy>;
  vendor: IntegrationVendor;
  yearOfProduction: Scalars['Int']['output'];
};

export type ConfiguredIntegrationVendorVehicleChargeState = {
  __typename?: 'ConfiguredIntegrationVendorVehicleChargeState';
  batteryCapacity: Scalars['Float']['output'];
  batteryLevel: Scalars['Int']['output'];
  chargeRate: Scalars['Float']['output'];
  chargeTimeRemaining: Scalars['Int']['output'];
  isCharging: Scalars['Boolean']['output'];
  isFullyCharged: Scalars['Boolean']['output'];
  isPluggedIn: Scalars['Boolean']['output'];
  range: Scalars['Float']['output'];
};

export type ConfiguredIntegrationVendorVehicleLocationState = GpsDisabledConfiguredIntegrationVendorVehicleLocationState | GpsNeverActivatedConfiguredIntegrationVendorVehicleLocationState | LocationAvailableConfiguredIntegrationVendorVehicleLocationState;

export enum ConfiguredIntegrationVendorVehicleLocationStateType {
  GpsDisabled = 'GPS_DISABLED',
  GpsNeverActivated = 'GPS_NEVER_ACTIVATED',
  LocationAvailable = 'LOCATION_AVAILABLE'
}

export type ConnectExternalUserInput = {
  userIdentifier: UserIdentifierInput;
};

export type ConnectExternalUserPayload = {
  __typename?: 'ConnectExternalUserPayload';
  /** Devices shipped to the user. If no devices have been shipped yet, the list is empty. Use the `ordersForUser` query to know the status of the user's orders. */
  devices: Array<DeviceInfo>;
  /** The sessions object contains an `accessToken` to be used by apps to run queries on behalf of the external user. This token will have permissions to get data for the devices shipped to the user. */
  session: SessionInfo;
  success: Scalars['Boolean']['output'];
  user: UserInfo;
};

export type ConsideringSmartChargingStatus = {
  __typename?: 'ConsideringSmartChargingStatus';
  consideration: SmartChargingConsideration;
  externalStart: Scalars['Boolean']['output'];
  type: SmartChargingStatusType;
};

/**
 * Capacity model where grid voltage and/or fuse size make the capacity steps.
 *
 * Capacity model used by Alut, NettiNord, SuNett.
 */
export type ConstantBusiness = {
  __typename?: 'ConstantBusiness';
  price: PriceSpecification;
  type: CapacityModelBusinessType;
  yearlyEnergyFund: PriceSpecification;
};

/** Energy model with same price for all times of the day, week and year */
export type ConstantPrice = {
  __typename?: 'ConstantPrice';
  pricesAndTaxes: PricesAndTaxes;
  rushPricing?: Maybe<Array<Maybe<RushPricingPeriod>>>;
  type: EnergyModelType;
};

/** Energy model with same price for all times of the day, week and year */
export type ConstantPriceBusiness = {
  __typename?: 'ConstantPriceBusiness';
  pricesAndTaxes: PricesAndTaxesBusiness;
  rushPricing?: Maybe<Array<Maybe<RushPricingPeriod>>>;
  type: EnergyModelBusinessType;
};

export type ConstantPriceDemandTariff = {
  __typename?: 'ConstantPriceDemandTariff';
  pricePerKw: PriceSpecification;
};

export type ConstantPriceWeightedDemandTariff = {
  __typename?: 'ConstantPriceWeightedDemandTariff';
  monthWeights: MonthWeights;
  pricePerKw: PriceSpecification;
};

export enum ConsumerType {
  Business = 'BUSINESS',
  Private = 'PRIVATE'
}

export enum ConsumerTypeEnterprise {
  EnterpriseHighVoltage = 'EnterpriseHighVoltage',
  EnterpriseLowVoltage = 'EnterpriseLowVoltage'
}

export type Controllable = {
  __typename?: 'Controllable';
  id: Scalars['String']['output'];
  intermediaryId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  type: ControllableType;
  vendor: Vendor;
};

export enum ControllableType {
  Room = 'ROOM'
}

export type ControllablesForUserPayload = {
  __typename?: 'ControllablesForUserPayload';
  controllables: Array<Controllable>;
};

export enum CountryCode {
  No = 'NO'
}

/**
 * Input object for creating charge settings.
 * - `defaultStartBatteryLevel` can be set as a default battery level for the beginning of a session, if we cannot get the SoC from the vehicle this value will be used.
 * - `departureTimes` is a list of departure times for each day of the week.
 * - `desiredBatteryLevel` is the battery level at which the car should be charged at the departure time.
 * - `directChargingBatteryLevel` is the battery level at which the car should start charging immediately.
 * - `enableSmartChargingAt` is the date at which smart charging should be enabled.
 * - `isSmartChargingEnabled` is whether smart charging is enabled.
 * - `isSolarChargingEnabled` is whether solar charging is enabled.
 * - `maxAllowedTargetSoC` is the maximum allowed target state of charge.
 * - `timeZone` is the time zone of the user.
 * - `vehicleId` is the id of the vehicle.
 */
export type CreateChargeSettingsInput = {
  defaultStartBatteryLevel?: InputMaybe<Scalars['Float']['input']>;
  departureTimes: DepartureTimesInput;
  desiredBatteryLevel: Scalars['Float']['input'];
  directChargingBatteryLevel: Scalars['Float']['input'];
  enableSmartChargingAt?: InputMaybe<Scalars['Date']['input']>;
  isSmartChargingEnabled: Scalars['Boolean']['input'];
  isSolarChargingEnabled: Scalars['Boolean']['input'];
  maxAllowedTargetSoC: Scalars['Float']['input'];
  timeZone: Timezone;
  vehicleId: Scalars['String']['input'];
};

/** Response object when creating charge settings. */
export type CreateChargeSettingsPayload = {
  __typename?: 'CreateChargeSettingsPayload';
  chargeSettings: ChargeSettings;
};

export type CreateJedlixChargingLocationInput = {
  address: JedlixAddressInput;
  coordinates: LatLngInput;
};

export type CreateJedlixUserInput = {
  defaultCountry: CountryCode;
  locale: Scalars['String']['input'];
};

export type CreationInfo = {
  __typename?: 'CreationInfo';
  at: Scalars['Date']['output'];
  by: UserInfo;
};

export enum Currency {
  Nok = 'NOK',
  Sek = 'SEK'
}

export type CurrentIntermediaryPayload = {
  __typename?: 'CurrentIntermediaryPayload';
  alertSettings?: Maybe<Array<AlertSetting>>;
};


export type CurrentIntermediaryPayloadAlertSettingsArgs = {
  input?: InputMaybe<IntermediaryAlertSettingsInput>;
};

export type CurrentRangeMonthlyPrice = {
  __typename?: 'CurrentRangeMonthlyPrice';
  /** From, exclusive */
  fromCurrent: Scalars['Int']['output'];
  /** Price for this current range */
  monthlyPrice: PriceSpecification;
  /** To, inclusive */
  toCurrent: Scalars['Int']['output'];
};

export type CurrentRangePrice = {
  __typename?: 'CurrentRangePrice';
  /** From, exclusive */
  fromCurrent: Scalars['Int']['output'];
  /** To, inclusive */
  toCurrent: Scalars['Int']['output'];
  /** Price for this current range */
  yearlyPrice: PriceSpecification;
};

export type CurrentRangeWithSelectable = {
  __typename?: 'CurrentRangeWithSelectable';
  fromCurrent: Scalars['Int']['output'];
  selectableEnergyModel: SelectableEnergyModel;
  toCurrent: Scalars['Int']['output'];
};

export type CurrentRangeWithSelectableBusiness = {
  __typename?: 'CurrentRangeWithSelectableBusiness';
  fromCurrent: Scalars['Int']['output'];
  selectableEnergyModel: SelectableEnergyModelBusiness;
  toCurrent: Scalars['Int']['output'];
};

export type CustomError = {
  message: Scalars['String']['output'];
  type: ErrorType;
};

export type DataInput = {
  records: Array<ActiveEnergyImportedRecordInput>;
};

export type DateRange = {
  __typename?: 'DateRange';
  /** Day of month and month as a number, including this date */
  from: DayAndMonth;
  /** Day of month and month as a number, excluding this date */
  until: DayAndMonth;
};

export type DayAndMonth = {
  __typename?: 'DayAndMonth';
  day: Scalars['Int']['output'];
  month: Month;
};

/**
 * There may be different prices for day and night, maybe in combination with
 * seasonal (summer/winter) prices. Usually the day is from 6 to 22, but not
 * always.
 */
export type DayAndNightPrices = {
  __typename?: 'DayAndNightPrices';
  day: PricesAndTaxesForPartOfDay;
  night: PricesAndTaxesForPartOfDay;
};

/**
 * There may be different prices for day and night, maybe in combination with
 * seasonal (summer/winter) prices. Usually the day is from 6 to 22, but not
 * always.
 */
export type DayAndNightPricesBusiness = {
  __typename?: 'DayAndNightPricesBusiness';
  day: PricesAndTaxesForPartOfDayBusiness;
  night: PricesAndTaxesForPartOfDayBusiness;
};

export type DeleteAlertSettingInput = {
  id: Scalars['ID']['input'];
};

export type DeleteAlertSettingPayload = {
  __typename?: 'DeleteAlertSettingPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteChargingLocationInput = {
  chargingLocationId: Scalars['String']['input'];
};

export type DeleteChargingLocationPayload = {
  __typename?: 'DeleteChargingLocationPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteJedlixChargingLocationInput = {
  chargingLocationId: Scalars['String']['input'];
};

export type DeleteJedlixChargingLocationPayload = {
  __typename?: 'DeleteJedlixChargingLocationPayload';
  response?: Maybe<Scalars['Void']['output']>;
};

export type DeleteJedlixUserPayload = {
  __typename?: 'DeleteJedlixUserPayload';
  response?: Maybe<Scalars['Void']['output']>;
};

export type DeleteJedlixVehicleInput = {
  vehicleId: Scalars['String']['input'];
};

export type DeleteJedlixVehiclePayload = {
  __typename?: 'DeleteJedlixVehiclePayload';
  response?: Maybe<Scalars['Void']['output']>;
};

export type DeleteMeInput = {
  accessToken: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type DeleteMePayload = {
  __typename?: 'DeleteMePayload';
  success: Scalars['Boolean']['output'];
  user: UserInfo;
};

export type DeliveryChargeArea = {
  __typename?: 'DeliveryChargeArea';
  id: DeliveryChargeModelId;
};

export type DeliveryChargeAreaInput = {
  addressInput?: InputMaybe<AddressInput>;
  latLngInput?: InputMaybe<LatLngInput>;
};

export type DeliveryChargeCapacityBusinessModel = ConstantBusiness | FuseAndVoltageSizeBusiness | MonthlyPeaksAtDifferentDaysBusiness | WeightedYearlyRollingPeaksInDifferentWeeksBusiness;

export type DeliveryChargeCapacityModel = FuseAndHomeBasedSelectableSeasonal | FuseAndHomeType | FuseAndVoltageSize | MonthlyPeaksAtDifferentDays | MonthlyPeaksAtDifferentDaysLinearWithBase | WeightedYearlyRollingPeaksInDifferentWeeks;

export type DeliveryChargeCost = {
  __typename?: 'DeliveryChargeCost';
  capacityCost: CapacityCost;
  energyCost: EnergyCost;
};

export type DeliveryChargeCostBusiness = {
  __typename?: 'DeliveryChargeCostBusiness';
  capacityCost: CapacityCost;
  energyCost: EnergyCost;
};

export type DeliveryChargeCostBusinessInput = {
  dataInput: DataInput;
  deliveryChargeModelId?: InputMaybe<DeliveryChargeModelId>;
  gln?: InputMaybe<Scalars['Gln']['input']>;
};

export type DeliveryChargeCostEnterprise = {
  __typename?: 'DeliveryChargeCostEnterprise';
  demandTariffCost: DemandTariffCost;
  energyCost: EnergyCost;
  fixedFeeCost: FixedFeeCost;
};

export type DeliveryChargeCostEnterpriseInput = {
  consumerType: ConsumerTypeEnterprise;
  dataInput: DataInput;
  deliveryChargeModelId?: InputMaybe<DeliveryChargeModelId>;
  gln?: InputMaybe<Scalars['Gln']['input']>;
};

export type DeliveryChargeCostInput = {
  dataInput: DataInput;
  deliveryChargeModelId?: InputMaybe<DeliveryChargeModelId>;
  gln?: InputMaybe<Scalars['Gln']['input']>;
};

export type DeliveryChargeDemandTariffEnterpriseModel = ConstantPriceDemandTariff | ConstantPriceWeightedDemandTariff | SeasonalPricesDemandTariff | SeasonalTieredDemandTariff | TieredDemandTariff;

export type DeliveryChargeEnergyBusinessModel = ConstantPriceBusiness | DemandChargeStepBusiness | DemandChargeStepWithSeasonsBusiness | DifferentPricesDayAndNightBusiness | DifferentPricesSeasonalBusiness | DifferentPricesSeasonalDayAndNightBusiness | FuseBasedSelectableBusiness | SelectableEnergyModelBusiness;

export type DeliveryChargeEnergyEnterpriseModel = ConstantPriceBusiness | DifferentPricesDayAndNightBusiness | DifferentPricesSeasonalBusiness;

export type DeliveryChargeEnergyModel = ConstantPrice | DifferentPricesDayAndNight | DifferentPricesSeasonal | DifferentPricesSeasonalDayAndNight | FuseBasedSelectable | HomeBasedSelectableSeasonal | SelectableEnergyModel;

/** Energy taxes (electrical power tax and energy fund tax) */
export type DeliveryChargeEnergyTaxes = {
  __typename?: 'DeliveryChargeEnergyTaxes';
  /** Electrical power tax (Avgift på elektrisk kraft, also called "forbruksavgift") */
  electricalPowerTax: PriceSpecification;
  /** Tax to the energy fund (Enova-avgift) */
  energyFund: PriceSpecification;
};

/** Energy taxes for business (electrical power tax) */
export type DeliveryChargeEnergyTaxesBusiness = {
  __typename?: 'DeliveryChargeEnergyTaxesBusiness';
  /** Electrical power tax (Avgift på elektrisk kraft, also called "forbruksavgift") */
  electricalPowerTax: PriceSpecification;
};

export type DeliveryChargeFixedFeeEnterpriseModel = PerMonthFixedFee | PerYearDividedByDaysFixedFee;

/** Return type for delivery charge models of type private */
export type DeliveryChargeModel = {
  __typename?: 'DeliveryChargeModel';
  capacityModel: DeliveryChargeCapacityModel;
  energyModel: DeliveryChargeEnergyModel;
  gln: Scalars['Gln']['output'];
  id: DeliveryChargeModelId;
  taxesApplicable: DeliveryChargeTaxesApplicable;
  timezone: Timezone;
  validFrom: Scalars['Date']['output'];
};

/** Return type for delivery charge models of type business */
export type DeliveryChargeModelBusiness = {
  __typename?: 'DeliveryChargeModelBusiness';
  capacityModel: DeliveryChargeCapacityBusinessModel;
  energyModel: DeliveryChargeEnergyBusinessModel;
  gln: Scalars['Gln']['output'];
  id: DeliveryChargeModelId;
  taxesApplicable: DeliveryChargeTaxesApplicable;
  timezone: Timezone;
  validFrom: Scalars['Date']['output'];
};

/** Input for delivery charge models of type business using `gln` or our `id` */
export type DeliveryChargeModelBusinessInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  gln?: InputMaybe<Scalars['Gln']['input']>;
  id?: InputMaybe<DeliveryChargeModelId>;
};

export type DeliveryChargeModelEnterprise = {
  __typename?: 'DeliveryChargeModelEnterprise';
  demandTariffModel: DeliveryChargeDemandTariffEnterpriseModel;
  energyModel: DeliveryChargeEnergyEnterpriseModel;
  fixedFeeModel: DeliveryChargeFixedFeeEnterpriseModel;
  gln: Scalars['Gln']['output'];
  id: DeliveryChargeModelId;
  taxesApplicable: DeliveryChargeTaxesApplicable;
  timezone: Timezone;
  validFrom: Scalars['Date']['output'];
};

export enum DeliveryChargeModelId {
  AgderEnergiNett = 'AGDER_ENERGI_NETT',
  AleEl = 'ALE_EL',
  Alut = 'ALUT',
  AndoyNett = 'ANDOY_NETT',
  Arva = 'ARVA',
  ArvikaTeknik = 'ARVIKA_TEKNIK',
  AskerNett = 'ASKER_NETT',
  AustevollKraftlag = 'AUSTEVOLL_KRAFTLAG',
  BarentsNett = 'BARENTS_NETT',
  BengtsforsEnergiNat = 'BENGTSFORS_ENERGI_NAT',
  BindalKraftlag = 'BINDAL_KRAFTLAG',
  BjareKraft = 'BJARE_KRAFT',
  BkkNett = 'BKK_NETT',
  BlasjonNat = 'BLASJON_NAT',
  BomloKraftnett = 'BOMLO_KRAFTNETT',
  BooEnergi = 'BOO_ENERGI',
  BreheimNett = 'BREHEIM_NETT',
  BrittedalsElnat = 'BRITTEDALS_ELNAT',
  DeNett = 'DE_NETT',
  Elinett = 'ELINETT',
  Ellevio = 'ELLEVIO',
  Elmea = 'ELMEA',
  Elvenett = 'ELVENETT',
  ElverketHoland = 'ELVERKET_HOLAND',
  Elvia = 'ELVIA',
  Enida = 'ENIDA',
  Etna = 'ETNA',
  Everket = 'EVERKET',
  Fagne = 'FAGNE',
  FaluElnat = 'FALU_ELNAT',
  FilipstadEnerginat = 'FILIPSTAD_ENERGINAT',
  Fjellnett = 'FJELLNETT',
  Foie = 'FOIE',
  Fore = 'FORE',
  FusaKraftlag = 'FUSA_KRAFTLAG',
  GislavedEnergi = 'GISLAVED_ENERGI',
  GlitreEnergiNett = 'GLITRE_ENERGI_NETT',
  GlitreNett = 'GLITRE_NETT',
  GotlandsEnergi = 'GOTLANDS_ENERGI',
  Griug = 'GRIUG',
  HallingdalKraftnett = 'HALLINGDAL_KRAFTNETT',
  HallstaviksElverk = 'HALLSTAVIKS_ELVERK',
  HalogalandKraftNett = 'HALOGALAND_KRAFT_NETT',
  Harjeans = 'HARJEANS',
  HarrydaEnergi = 'HARRYDA_ENERGI',
  Havnett = 'HAVNETT',
  Hemsil = 'HEMSIL',
  HjartumsElforening = 'HJARTUMS_ELFORENING',
  HjoElnat = 'HJO_ELNAT',
  HolandOgSetskogElverk = 'HOLAND_OG_SETSKOG_ELVERK',
  IndreHordalandKraftnett = 'INDRE_HORDALAND_KRAFTNETT',
  IsaltenNett = 'ISALTEN_NETT',
  Jamtkraft = 'JAMTKRAFT',
  JarenEverk = 'JAREN_EVERK',
  KarlsborgsElnat = 'KARLSBORGS_ELNAT',
  KeNett = 'KE_NETT',
  Klive = 'KLIVE',
  KungalvEnergi = 'KUNGALV_ENERGI',
  KvamEnergiNett = 'KVAM_ENERGI_NETT',
  Kystnett = 'KYSTNETT',
  LandskronaEnergi = 'LANDSKRONA_ENERGI',
  Lede = 'LEDE',
  LegaNett = 'LEGA_NETT',
  Lerum = 'LERUM',
  Leva = 'LEVA',
  LindeEnergi = 'LINDE_ENERGI',
  Linea = 'LINEA',
  Linja = 'LINJA',
  Lnett = 'LNETT',
  Lucerna = 'LUCERNA',
  LuostejokNett = 'LUOSTEJOK_NETT',
  Lysna = 'LYSNA',
  Mellom = 'MELLOM',
  MeloyNett = 'MELOY_NETT',
  Midtnett = 'MIDTNETT',
  MjolbyKraftnat = 'MJOLBY_KRAFTNAT',
  ModalenKraftlag = 'MODALEN_KRAFTLAG',
  MolndalEnergi = 'MOLNDAL_ENERGI',
  Morenett = 'MORENETT',
  NatkraftBoras = 'NATKRAFT_BORAS',
  Neas = 'NEAS',
  Nettinord = 'NETTINORD',
  Nettselskapet = 'NETTSELSKAPET',
  NjudungSavsjo = 'NJUDUNG_SAVSJO',
  NjudungVetlanda = 'NJUDUNG_VETLANDA',
  Nordlandsnett = 'NORDLANDSNETT',
  Nordvestnett = 'NORDVESTNETT',
  NorefjellNett = 'NOREFJELL_NETT',
  Norgesnett = 'NORGESNETT',
  NossebroEnergi = 'NOSSEBRO_ENERGI',
  OddaEnergiNett = 'ODDA_ENERGI_NETT',
  OlofstromsKraft = 'OLOFSTROMS_KRAFT',
  Olserods = 'OLSERODS',
  OvertorneaEnergi = 'OVERTORNEA_ENERGI',
  OvikEnergi = 'OVIK_ENERGI',
  OxeloEnergi = 'OXELO_ENERGI',
  RakkestadEnergi = 'RAKKESTAD_ENERGI',
  RaumaEnergi = 'RAUMA_ENERGI',
  RkNett = 'RK_NETT',
  RollagElverkNett = 'ROLLAG_ELVERK_NETT',
  Romsdalsnett = 'ROMSDALSNETT',
  RorosEverkNett = 'ROROS_EVERK_NETT',
  SandhultSandaredsElnat = 'SANDHULT_SANDAREDS_ELNAT',
  SandoyEnergi = 'SANDOY_ENERGI',
  SandvikenEnergi = 'SANDVIKEN_ENERGI',
  Sjogerstads = 'SJOGERSTADS',
  SkellefteaKraft = 'SKELLEFTEA_KRAFT',
  SkiakerNett = 'SKIAKER_NETT',
  SkjakEnergiNett = 'SKJAK_ENERGI_NETT',
  SkurupsElverk = 'SKURUPS_ELVERK',
  Soderhamn = 'SODERHAMN',
  SorAurdalEnergiNett = 'SOR_AURDAL_ENERGI_NETT',
  StangeEnergiNett = 'STANGE_ENERGI_NETT',
  Stannum = 'STANNUM',
  Stram = 'STRAM',
  StraumenNett = 'STRAUMEN_NETT',
  Straumnett = 'STRAUMNETT',
  Sunett = 'SUNETT',
  Sygnir = 'SYGNIR',
  SNett = 'S_NETT',
  TelemarkNett = 'TELEMARK_NETT',
  TendraNett = 'TENDRA_NETT',
  TensioTn = 'TENSIO_TN',
  TensioTs = 'TENSIO_TS',
  TindraNett = 'TINDRA_NETT',
  TranasEnergi = 'TRANAS_ENERGI',
  TrollfjordNett = 'TROLLFJORD_NETT',
  TrollhattanEnergi = 'TROLLHATTAN_ENERGI',
  TromsKraftNett = 'TROMS_KRAFT_NETT',
  UddevallaEnergi = 'UDDEVALLA_ENERGI',
  UlricehamnsEnergi = 'ULRICEHAMNS_ENERGI',
  UmeaEnergi = 'UMEA_ENERGI',
  UpplandsEnergi = 'UPPLANDS_ENERGI',
  UvdalKraftforsyning = 'UVDAL_KRAFTFORSYNING',
  VaggerydsElverk = 'VAGGERYDS_ELVERK',
  Vanerenergi = 'VANERENERGI',
  VangEnergi = 'VANG_ENERGI',
  Varbergsortens = 'VARBERGSORTENS',
  VasterbergslagensElnat = 'VASTERBERGSLAGENS_ELNAT',
  Vattenfall = 'VATTENFALL',
  Vestall = 'VESTALL',
  VestmarNett = 'VESTMAR_NETT',
  VesttelemarkKraftlag = 'VESTTELEMARK_KRAFTLAG',
  Vevig = 'VEVIG',
  Vissi = 'VISSI',
  Vonett = 'VONETT'
}

/** Query delivery charge models using `gln` or our `id` */
export type DeliveryChargeModelInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  gln?: InputMaybe<Scalars['Gln']['input']>;
  id?: InputMaybe<DeliveryChargeModelId>;
};

export type DeliveryChargeTaxesApplicable = {
  __typename?: 'DeliveryChargeTaxesApplicable';
  electricalPowerTax: Scalars['Boolean']['output'];
  vat: Scalars['Boolean']['output'];
};

export enum DemandChargePeriod {
  Month = 'Month',
  Year = 'Year'
}

export type DemandChargeRange = {
  __typename?: 'DemandChargeRange';
  fromKw: Scalars['Int']['output'];
  untilKw: Scalars['Int']['output'];
};

export type DemandChargeSeason = {
  __typename?: 'DemandChargeSeason';
  months: MonthRange;
  pricePerKw: PriceSpecification;
};

export type DemandChargeSeasons = {
  __typename?: 'DemandChargeSeasons';
  summer: DemandChargeSeason;
  winter: DemandChargeSeason;
};

export type DemandChargeStep = {
  __typename?: 'DemandChargeStep';
  pricePerKw: PriceSpecification;
  rangeInKw: DemandChargeRange;
};

export type DemandChargeStepBusiness = {
  __typename?: 'DemandChargeStepBusiness';
  demandChargeAboveStepsPerKw: PriceSpecification;
  demandChargePeriod: DemandChargePeriod;
  demandChargeSteps: Array<DemandChargeStep>;
  energyPricePerKwh: PricesAndTaxesBusiness;
  type: EnergyModelBusinessType;
};

export type DemandChargeStepWithSeasons = {
  __typename?: 'DemandChargeStepWithSeasons';
  rangeInKw: DemandChargeRange;
  seasons: DemandChargeSeasons;
};

export type DemandChargeStepWithSeasonsBusiness = {
  __typename?: 'DemandChargeStepWithSeasonsBusiness';
  demandChargeAboveSteps: DemandChargeSeasons;
  demandChargePeriod: DemandChargePeriod;
  demandChargeStepsWithSeasons: Array<DemandChargeStepWithSeasons>;
  energyPricePerKwh: PricesAndTaxesBusiness;
  type: EnergyModelBusinessType;
};

export type DemandTariffCost = {
  __typename?: 'DemandTariffCost';
  cost: PriceSpecification;
};

export type DemandTariffTier = {
  __typename?: 'DemandTariffTier';
  powerRangeInKw: PowerRangeInKw;
  pricePerKw: PriceSpecification;
};

/**
 * Type departure times on charge settings.
 * - `departureTimeOverride` is the departure time override for the current day (Optional).
 * - `monday` is the departure time for Monday with format `HH:mm`.
 * - ... etc.
 */
export type DepartureTimes = {
  __typename?: 'DepartureTimes';
  departureTimeOverride?: Maybe<Scalars['Date']['output']>;
  friday: Scalars['String']['output'];
  monday: Scalars['String']['output'];
  saturday: Scalars['String']['output'];
  sunday: Scalars['String']['output'];
  thursday: Scalars['String']['output'];
  tuesday: Scalars['String']['output'];
  wednesday: Scalars['String']['output'];
};

/**
 * Input object for setting departure times on charge settings.
 * - `departureTimeOverride` is the departure time override for the current day (Optional).
 * - `monday` is the departure time for Monday with format `HH:mm`.
 * - ... etc.
 */
export type DepartureTimesInput = {
  departureTimeOverride?: InputMaybe<Scalars['Date']['input']>;
  friday: Scalars['String']['input'];
  monday: Scalars['String']['input'];
  saturday: Scalars['String']['input'];
  sunday: Scalars['String']['input'];
  thursday: Scalars['String']['input'];
  tuesday: Scalars['String']['input'];
  wednesday: Scalars['String']['input'];
};

export type DeviceFilter = {
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recentMeterIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DeviceIdentifierInput = {
  deviceId?: InputMaybe<Scalars['DeviceId']['input']>;
  meterId?: InputMaybe<Scalars['MeterId']['input']>;
};

export type DeviceInfo = {
  __typename?: 'DeviceInfo';
  activation?: Maybe<Activation>;
  claimId: Scalars['String']['output'];
  claimedAt?: Maybe<Scalars['String']['output']>;
  claimedBy?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['String']['output'];
  deviceName?: Maybe<Scalars['String']['output']>;
  diagnostic?: Maybe<DiagnosticInfo>;
  intermediaryId?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<DeviceMetadata>;
  ownedBy?: Maybe<OwnedByUserInfo>;
  permissions: Array<DevicePermission>;
  preferredEnergyBiddingZone?: Maybe<EnergyBiddingZone>;
  recentMeter?: Maybe<RecentMeter>;
  recentMeterId?: Maybe<Scalars['MeterId']['output']>;
  refurbishInfo?: Maybe<RefurbishInfo>;
  returnInfo?: Maybe<ReturnInfo>;
  shippedAt?: Maybe<Scalars['String']['output']>;
  shippedTo?: Maybe<ShippedToUserInfo>;
  subscription?: Maybe<SubscriptionBilling>;
  type: Scalars['String']['output'];
  updateStatus?: Maybe<DeviceUpdateStatus>;
  webhookCallbackUrl?: Maybe<Scalars['String']['output']>;
};

export type DeviceInput = {
  id: Scalars['String']['input'];
  metadata: DeviceMetadataInput;
  type: DeviceType;
};

export type DeviceMetadata = {
  __typename?: 'DeviceMetadata';
  chip?: Maybe<Scalars['String']['output']>;
  espIdfVersionFactoryPartition?: Maybe<Scalars['String']['output']>;
  firmwareTheme?: Maybe<Scalars['String']['output']>;
  firmwareVersionFactoryPartition?: Maybe<Scalars['String']['output']>;
  iccid?: Maybe<Scalars['String']['output']>;
  imei?: Maybe<Scalars['String']['output']>;
  memoryPartitioning?: Maybe<Scalars['String']['output']>;
  modemFirmwareVersion?: Maybe<Scalars['String']['output']>;
  productBatch?: Maybe<Scalars['String']['output']>;
};

export type DeviceMetadataInput = {
  chip: Scalars['String']['input'];
  espIdfVersionFactoryPartition: Scalars['String']['input'];
  firmwareTheme: Scalars['String']['input'];
  firmwareVersionFactoryPartition: Scalars['String']['input'];
  iccid?: InputMaybe<Scalars['String']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  memoryPartitioning: Scalars['String']['input'];
  modemFirmwareVersion?: InputMaybe<Scalars['String']['input']>;
  productBatch: Scalars['String']['input'];
};

/**
 * Input object for updating ownership information
 *
 * Fields will be replaced and missing fields will be removed
 */
export type DeviceOwnerInput = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  externalUserId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalAddress?: InputMaybe<OptionalFieldsPostalAddressInput>;
};

export type DevicePermission = {
  __typename?: 'DevicePermission';
  permittedEmail: Scalars['String']['output'];
  permittedUserId: Scalars['String']['output'];
};

export type DeviceQueryIdentifier = {
  claimId?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  recentMeterId?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceQueryInput = {
  identifier: DeviceQueryIdentifier;
};

export type DeviceQueryPayload = {
  __typename?: 'DeviceQueryPayload';
  device: DeviceInfo;
};

export type DeviceRefurbishParts = {
  __typename?: 'DeviceRefurbishParts';
  backCasingOk: Scalars['Boolean']['output'];
  boxDeviceLabelOk: Scalars['Boolean']['output'];
  cardboardBoxOk: Scalars['Boolean']['output'];
  deviceLabelOk: Scalars['Boolean']['output'];
  deviceTypeStickerOk: Scalars['Boolean']['output'];
  frontCasingOk: Scalars['Boolean']['output'];
  manualOk: Scalars['Boolean']['output'];
  pcbaOk: Scalars['Boolean']['output'];
  rj45Ok: Scalars['Boolean']['output'];
  sealOk: Scalars['Boolean']['output'];
  usbOk?: Maybe<Scalars['Boolean']['output']>;
};

export type DeviceStats = {
  __typename?: 'DeviceStats';
  devicesActivated: Scalars['Int']['output'];
  devicesActivationReady: Scalars['Int']['output'];
  devicesAtCustomer: Scalars['Int']['output'];
  devicesDeactivated: Scalars['Int']['output'];
  returnedDevices: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** The type of device */
export enum DeviceType {
  HanLtem = 'HAN_LTEM',
  HanWifi = 'HAN_WIFI'
}

export type DeviceUpdateStatus = {
  __typename?: 'DeviceUpdateStatus';
  finishedAt?: Maybe<Scalars['Date']['output']>;
  progressPercent: Scalars['Int']['output'];
  startedAt: Scalars['Date']['output'];
  updatedAt: Scalars['Date']['output'];
  version: Scalars['Int']['output'];
};

/** Diagnostic about network state and reboots */
export type DiagnosticInfo = {
  __typename?: 'DiagnosticInfo';
  firmwareVersion?: Maybe<Scalars['Int']['output']>;
  hanEnergy?: Maybe<Scalars['Boolean']['output']>;
  lastMessageAt?: Maybe<Scalars['Date']['output']>;
  lastPingAt?: Maybe<Scalars['Date']['output']>;
  publishInterval?: Maybe<Scalars['Float']['output']>;
  reboots?: Maybe<Scalars['Int']['output']>;
  signalStrength?: Maybe<Scalars['Int']['output']>;
};

/**
 * Energy model with different prices for day and night, may also have different prices for
 * weekends and holidays
 */
export type DifferentPricesDayAndNight = {
  __typename?: 'DifferentPricesDayAndNight';
  holidayPricesFollowNightPrices: Scalars['Boolean']['output'];
  prices: DayAndNightPrices;
  type: EnergyModelType;
  weekendPricesFollowNightPrices: Scalars['Boolean']['output'];
};

/**
 * Has different prices for day and night, may also have different prices for
 * weekends and holidays
 */
export type DifferentPricesDayAndNightBusiness = {
  __typename?: 'DifferentPricesDayAndNightBusiness';
  holidayPricesFollowNightPrices: Scalars['Boolean']['output'];
  prices: DayAndNightPricesBusiness;
  type: EnergyModelBusinessType;
  weekendPricesFollowNightPrices: Scalars['Boolean']['output'];
};

/** Energy model with different prices for summer and winter */
export type DifferentPricesSeasonal = {
  __typename?: 'DifferentPricesSeasonal';
  seasons: SeasonalPricesWithoutDayAndNight;
  type: EnergyModelType;
};

/** Has different prices for summer and winter */
export type DifferentPricesSeasonalBusiness = {
  __typename?: 'DifferentPricesSeasonalBusiness';
  seasons: SeasonalPricesWithoutDayAndNightBusiness;
  type: EnergyModelBusinessType;
};

/**
 * Energy model with different prices for summer and winter, day and night, may also have
 * different prices for weekends and holidays
 */
export type DifferentPricesSeasonalDayAndNight = {
  __typename?: 'DifferentPricesSeasonalDayAndNight';
  holidayPricesFollowNightPrices: Scalars['Boolean']['output'];
  seasons: SeasonalPrices;
  type: EnergyModelType;
  weekendPricesFollowNightPrices: Scalars['Boolean']['output'];
};

/**
 * Has different prices for summer and winter, day and night, may also have
 * different prices for weekends and holidays
 */
export type DifferentPricesSeasonalDayAndNightBusiness = {
  __typename?: 'DifferentPricesSeasonalDayAndNightBusiness';
  holidayPricesFollowNightPrices: Scalars['Boolean']['output'];
  seasons: SeasonalPricesBusiness;
  type: EnergyModelBusinessType;
  weekendPricesFollowNightPrices: Scalars['Boolean']['output'];
};

export type DisabledSmartChargingStatus = {
  __typename?: 'DisabledSmartChargingStatus';
  externalStart: Scalars['Boolean']['output'];
  type: SmartChargingStatusType;
};

export type DisconnectVendorInput = {
  vendor: IntegrationVendor;
};

export type DisconnectVendorPayload = {
  __typename?: 'DisconnectVendorPayload';
  success: Scalars['Boolean']['output'];
};

/** Return type for electrical power taxes */
export type ElectricalPowerTaxes = {
  __typename?: 'ElectricalPowerTaxes';
  electricalPowerTax: Scalars['Float']['output'];
  validFrom: Scalars['Date']['output'];
  vatPart: Scalars['Float']['output'];
};

/** Query electrical power taxes */
export type ElectricalPowerTaxesInput = {
  /** Defaults to 'PRIVATE' if not specified */
  consumerType?: InputMaybe<ConsumerType>;
  /** Defaults to 'NO' if not specified */
  countryCode?: InputMaybe<CountryCode>;
  /** Defaults to today if not specified */
  date?: InputMaybe<Scalars['Date']['input']>;
};

export type EmailActionInput = {
  email: Scalars['String']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};

export type EmailIdentity = IdentityBase & {
  __typename?: 'EmailIdentity';
  email: Scalars['String']['output'];
  type: IdentityType;
};

export type EmailIdentityInput = {
  email: Scalars['String']['input'];
};

export type EndUserAlertSettingCreator = {
  __typename?: 'EndUserAlertSettingCreator';
  type: AlertSettingCreatorType;
  userId: Scalars['ID']['output'];
};

/** Energy bidding zones, as reported by the _European Network of Transmission System Operators for Electricity_ (ENTSO-E). */
export enum EnergyBiddingZone {
  /** Norway: south east */
  No1 = 'NO1',
  /** Norway: south */
  No2 = 'NO2',
  /** Norway: mid */
  No3 = 'NO3',
  /** Norway: north */
  No4 = 'NO4',
  /** Norway: west */
  No5 = 'NO5',
  Unrecognized = 'UNRECOGNIZED'
}

export type EnergyCost = {
  __typename?: 'EnergyCost';
  cost: PricesAndTaxes;
};

/** Return type for energy fund taxes */
export type EnergyFundTaxes = {
  __typename?: 'EnergyFundTaxes';
  energyFundTax: Scalars['Float']['output'];
  validFrom: Scalars['Date']['output'];
  vatPart: Scalars['Float']['output'];
  yearlyEnergyFundTax: Scalars['Float']['output'];
};

/** Query energy fund taxes */
export type EnergyFundTaxesInput = {
  /** Defaults to 'PRIVATE' if not specified */
  consumerType?: InputMaybe<ConsumerType>;
  /** Defaults to 'NO' if not specified */
  countryCode?: InputMaybe<CountryCode>;
  /** Defaults to today if not specified */
  date?: InputMaybe<Scalars['Date']['input']>;
};

export enum EnergyModelBusinessType {
  ConstantPriceBusiness = 'ConstantPriceBusiness',
  DemandChargeStepBusiness = 'DemandChargeStepBusiness',
  DemandChargeStepWithSeasonsBusiness = 'DemandChargeStepWithSeasonsBusiness',
  DifferentPricesDayAndNightBusiness = 'DifferentPricesDayAndNightBusiness',
  DifferentPricesSeasonalBusiness = 'DifferentPricesSeasonalBusiness',
  DifferentPricesSeasonalDayAndNightBusiness = 'DifferentPricesSeasonalDayAndNightBusiness',
  FuseBasedSelectableBusiness = 'FuseBasedSelectableBusiness',
  SelectableEnergyModelBusiness = 'SelectableEnergyModelBusiness'
}

export type EnergyModelSeasonalConstant = {
  __typename?: 'EnergyModelSeasonalConstant';
  highDemand: PricesForPartOfYearWithoutDayAndNight;
  highDemandHoursForWorkDays?: Maybe<HourRange>;
  lowDemand: PricesForPartOfYearWithoutDayAndNight;
};

export enum EnergyModelType {
  ConstantPrice = 'ConstantPrice',
  DifferentPricesDayAndNight = 'DifferentPricesDayAndNight',
  DifferentPricesSeasonal = 'DifferentPricesSeasonal',
  DifferentPricesSeasonalDayAndNight = 'DifferentPricesSeasonalDayAndNight',
  FuseBasedSelectable = 'FuseBasedSelectable',
  HomeBasedSelectableSeasonal = 'HomeBasedSelectableSeasonal',
  SelectableEnergyModel = 'SelectableEnergyModel'
}

export type EnergyPriceOfHour = {
  __typename?: 'EnergyPriceOfHour';
  from?: Maybe<Scalars['Date']['output']>;
  priceSpecification?: Maybe<PriceSpecification>;
  to?: Maybe<Scalars['Date']['output']>;
};

/**
 * Energy range is inclusive the from and to fields. A normal range is from 0 to
 * 1999 Wh. The granularity of our data is in Wh.
 */
export type EnergyRangeInWh = {
  __typename?: 'EnergyRangeInWh';
  /** From, inclusive */
  from: Scalars['Int']['output'];
  /** To, inclusive */
  to: Scalars['Int']['output'];
};

export type Error = UserNotAuthenticatedError | UserNotPermittedError;

export enum ErrorType {
  UserNotAuthenticatedError = 'UserNotAuthenticatedError',
  UserNotPermittedError = 'UserNotPermittedError'
}

/** An event type describes the EstimatedHourlyActiveEnergyLimitWarningAlertSetting event. */
export type EstimatedConsumptionWarningEvent = {
  __typename?: 'EstimatedConsumptionWarningEvent';
  alertSettingId: Scalars['String']['output'];
  alertType: SentAlertAlertType;
  at: Scalars['Date']['output'];
  deviceId: Scalars['String']['output'];
  energyUsed?: Maybe<Scalars['Float']['output']>;
  intermediaryId?: Maybe<Scalars['String']['output']>;
  limitInWattHours: Scalars['Float']['output'];
  notificationChannelType: NotificationChannelType;
  type: AlertEventType;
  userId?: Maybe<Scalars['String']['output']>;
};

/** An alert that continuously evaluates whether the device has crossed a set limit for energy consumption within the current hour. */
export type EstimatedHourlyActiveEnergyLimitWarningAlertSetting = {
  __typename?: 'EstimatedHourlyActiveEnergyLimitWarningAlertSetting';
  alertType: AlertType;
  createdBy: AlertSettingCreator;
  deviceId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  limitInWattHours: Scalars['Int']['output'];
  notificationChannels: Array<NotificationChannel>;
};

export type ExternalUserIdentifier = {
  __typename?: 'ExternalUserIdentifier';
  externalId: Scalars['String']['output'];
};

export type ExternalUserIdentifierInput = {
  externalId: Scalars['String']['input'];
};

export type ExternalUserIdentity = IdentityBase & {
  __typename?: 'ExternalUserIdentity';
  externalId: Scalars['String']['output'];
  intermediaryId: Scalars['String']['output'];
  type: IdentityType;
};

export type FixedFeeCost = {
  __typename?: 'FixedFeeCost';
  cost: PricesAndTaxes;
};

export type FullyChargedSmartChargingStatus = {
  __typename?: 'FullyChargedSmartChargingStatus';
  externalStart: Scalars['Boolean']['output'];
  type: SmartChargingStatusType;
};

/**
 * Capacity model were users can select whether they want a seasonal or constant price model (in combination with the energy model)
 *
 * Capacity model used in some Swedish regions.
 */
export type FuseAndHomeBasedSelectableSeasonal = {
  __typename?: 'FuseAndHomeBasedSelectableSeasonal';
  /** Prices for apartments */
  apartments: MonthlyPriceSpecification;
  /** Prices for houses */
  houses: FuseBasedSelectableSeasonal;
  type: CapacityModelType;
  /** Yearly transmission fees */
  yearlyEnergyFund: PriceSpecification;
};

/**
 * Capacity model where fuse size and type of home make the capacity steps.
 *
 * Capacity model used in some Swedish regions.
 */
export type FuseAndHomeType = {
  __typename?: 'FuseAndHomeType';
  /** Prices for apartments */
  apartments: FuseAndHomeTypePrices;
  /** Prices for houses */
  houses: FuseAndHomeTypePrices;
  type: CapacityModelType;
  /** Yearly transmission fees */
  yearlyEnergyFund: PriceSpecification;
};

export type FuseAndHomeTypePrices = {
  __typename?: 'FuseAndHomeTypePrices';
  currentRangePrices: Array<CurrentRangePrice>;
  yearlyPriceAboveCurrentRanges: PriceSpecification;
};

/**
 * Capacity model where grid voltage and/or fuse size make the capacity steps.
 *
 * Capacity model used by Alut, NettiNord, SuNett.
 */
export type FuseAndVoltageSize = {
  __typename?: 'FuseAndVoltageSize';
  /** Prices for one phase networks */
  onePhasePrices: PhasePrices;
  /** Prices for three phase networks */
  threePhasePrices: PhasePrices;
  type: CapacityModelType;
};

/**
 * Capacity model where grid voltage and/or fuse size make the capacity steps.
 *
 * Capacity model used by Alut, NettiNord, SuNett.
 */
export type FuseAndVoltageSizeBusiness = {
  __typename?: 'FuseAndVoltageSizeBusiness';
  /** Prices for one phase networks */
  onePhasePrices: PhasePrices;
  /** Prices for three phase networks */
  threePhasePrices: PhasePrices;
  type: CapacityModelBusinessType;
  yearlyEnergyFund: PriceSpecification;
};

/** Energy model that starts fuse based, but where the customers can select different models in some cases */
export type FuseBasedSelectable = {
  __typename?: 'FuseBasedSelectable';
  onePhasePrices: SelectablePhasePrices;
  threePhasePrices: SelectablePhasePrices;
  type: EnergyModelType;
};

/** A model that starts fuse based, but where the customers can select different models in some cases */
export type FuseBasedSelectableBusiness = {
  __typename?: 'FuseBasedSelectableBusiness';
  onePhasePrices: SelectablePhasePricesBusiness;
  threePhasePrices: SelectablePhasePricesBusiness;
  type: EnergyModelBusinessType;
};

export type FuseBasedSelectableSeasonal = {
  __typename?: 'FuseBasedSelectableSeasonal';
  regular: Array<CurrentRangeMonthlyPrice>;
  seasonal: Array<CurrentRangeMonthlyPrice>;
};

/** Input for the `getChargeSettings` query */
export type GetChargeSettingsInput = {
  vehicleId: Scalars['String']['input'];
};

/** Payload for the `getChargeSettings` query */
export type GetChargeSettingsPayload = {
  __typename?: 'GetChargeSettingsPayload';
  chargeSettings: ChargeSettings;
};

export type GetJedlixChargeSettingsInput = {
  vehicleId: Scalars['String']['input'];
};

export type GpsDisabledConfiguredIntegrationVendorVehicleLocationState = {
  __typename?: 'GpsDisabledConfiguredIntegrationVendorVehicleLocationState';
  type: ConfiguredIntegrationVendorVehicleLocationStateType;
};

export type GpsNeverActivatedConfiguredIntegrationVendorVehicleLocationState = {
  __typename?: 'GpsNeverActivatedConfiguredIntegrationVendorVehicleLocationState';
  type: ConfiguredIntegrationVendorVehicleLocationStateType;
};

export type GrantDeviceAccessInput = {
  deviceId: Scalars['String']['input'];
  permittedIdentity: EmailIdentityInput;
};

/**
 * Energy model were users can select whether they want a seasonal or constant price model (in combination with the capacity model)
 *
 * Energy model used in some Swedish regions.
 */
export type HomeBasedSelectableSeasonal = {
  __typename?: 'HomeBasedSelectableSeasonal';
  /** Prices for apartments */
  apartments: PricesAndTaxes;
  /** Prices for houses */
  houses: SelectableSeasonal;
  type: EnergyModelType;
};

export type HourRange = {
  __typename?: 'HourRange';
  /** 0-23, including start */
  from: Scalars['Int']['output'];
  /** 0-23, excluding end */
  until: Scalars['Int']['output'];
};

/** An alert that is evaluated 30 minutes into the hour and checks if the device's energy consumption is about to exceed a set limit. */
export type HourlyConsumptionLimitEstimationWarningAlertSetting = {
  __typename?: 'HourlyConsumptionLimitEstimationWarningAlertSetting';
  alertType: AlertType;
  createdBy: AlertSettingCreator;
  deviceId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  limitInWatts: Scalars['Int']['output'];
  notificationChannels: Array<NotificationChannel>;
};

/** An event type that is used if HourlyConsumptionLimitEstimationWarningAlertSetting was triggered. */
export type HourlyConsumptionReachedEvent = {
  __typename?: 'HourlyConsumptionReachedEvent';
  activeEnergyImported: Scalars['Float']['output'];
  alertSettingId: Scalars['String']['output'];
  alertType: SentAlertAlertType;
  at: Scalars['Date']['output'];
  deviceId: Scalars['String']['output'];
  intermediaryId?: Maybe<Scalars['String']['output']>;
  limitInWatts: Scalars['Float']['output'];
  notificationChannelType: NotificationChannelType;
  type: AlertEventType;
  userId?: Maybe<Scalars['String']['output']>;
};

/** An event type that describes the HourlyConsumptionLimitEstimationWarningAlertSetting event. */
export type HourlyConsumptionWarningEvent = {
  __typename?: 'HourlyConsumptionWarningEvent';
  activePowerImportAverage: Scalars['Float']['output'];
  alertSettingId: Scalars['String']['output'];
  alertType: SentAlertAlertType;
  at: Scalars['Date']['output'];
  consumptionThisFarInTheCurrentHourInWatts: Scalars['Float']['output'];
  deviceId: Scalars['String']['output'];
  intermediaryId?: Maybe<Scalars['String']['output']>;
  limitInWatts: Scalars['Float']['output'];
  notificationChannelType: NotificationChannelType;
  type: AlertEventType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type Identity = EmailIdentity | ExternalUserIdentity | IntermediaryApiKeyIdentity | InternalIdentity;

export type IdentityBase = {
  type: IdentityType;
};

export enum IdentityType {
  EmailIdentity = 'EmailIdentity',
  ExternalUserIdentity = 'ExternalUserIdentity',
  IntermediaryApiKeyIdentity = 'IntermediaryApiKeyIdentity',
  InternalIdentity = 'InternalIdentity'
}

export type IntegrationAuthorizationUrlInput = {
  vendor: IntegrationVendor;
};

export type IntegrationAuthorizationUrlResponse = {
  __typename?: 'IntegrationAuthorizationUrlResponse';
  authorizationUrl: Scalars['String']['output'];
};

export type IntegrationSessionInput = {
  integration: IntegrationType;
  redirectUrl: Scalars['String']['input'];
};

export type IntegrationSessionPayload = {
  __typename?: 'IntegrationSessionPayload';
  url: Scalars['String']['output'];
};

export enum IntegrationType {
  Mill = 'MILL',
  Zaptec = 'ZAPTEC'
}

export enum IntegrationVendor {
  Audi = 'AUDI',
  Bmw = 'BMW',
  Cupra = 'CUPRA',
  Jaguar = 'JAGUAR',
  Mini = 'MINI',
  Porsche = 'PORSCHE',
  Renault = 'RENAULT',
  Seat = 'SEAT',
  Skoda = 'SKODA',
  Tesla = 'TESLA',
  Volkswagen = 'VOLKSWAGEN',
  Volvo = 'VOLVO'
}

export type IntegrationVendorInfo = ConfiguredIntegrationVendorInfo | NotConfiguredIntegrationVendorInfo;

export enum IntegrationVendorStatus {
  Configured = 'CONFIGURED',
  NotConfigured = 'NOT_CONFIGURED'
}

export type IntermediaryAlertSettingCreator = {
  __typename?: 'IntermediaryAlertSettingCreator';
  intermediaryId: Scalars['String']['output'];
  type: AlertSettingCreatorType;
};

export type IntermediaryAlertSettingsFilter = {
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IntermediaryAlertSettingsInput = {
  filter?: InputMaybe<IntermediaryAlertSettingsFilter>;
};

/** Intermediary api keys are authorized at the intermediate level, to add or remove users on behalf of the intermediary. */
export type IntermediaryApiKey = {
  __typename?: 'IntermediaryApiKey';
  apiKey?: Maybe<Scalars['String']['output']>;
  created: CreationInfo;
  id: Scalars['ID']['output'];
  intermediaryId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  secret?: Maybe<Scalars['String']['output']>;
  startOfSecret: Scalars['String']['output'];
  /** @deprecated Use `apiKey` */
  token?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type IntermediaryApiKeyIdentity = IdentityBase & {
  __typename?: 'IntermediaryApiKeyIdentity';
  apiKeyHash: Scalars['String']['output'];
  type: IdentityType;
};

export type IntermediaryApiKeyPayload = {
  __typename?: 'IntermediaryApiKeyPayload';
  intermediaryApiKey: IntermediaryApiKey;
};

export type IntermediaryApiKeys = {
  __typename?: 'IntermediaryApiKeys';
  keys: Array<IntermediaryApiKey>;
};

export type IntermediaryApiKeysResult = IntermediaryApiKeys;

/** An intermediary is the entity or organization that has support responsibility for the devices. */
export type IntermediaryInfo = {
  __typename?: 'IntermediaryInfo';
  apiKeys?: Maybe<IntermediaryApiKeysResult>;
  deviceStats?: Maybe<DeviceStats>;
  devices?: Maybe<Array<DeviceInfo>>;
  id: Scalars['ID']['output'];
  permissionScopes?: Maybe<Array<Scalars['String']['output']>>;
};


/** An intermediary is the entity or organization that has support responsibility for the devices. */
export type IntermediaryInfoDevicesArgs = {
  search?: InputMaybe<Search>;
};

export enum IntermediaryUserScope {
  ReadBufferedMeasurements = 'READ_BUFFERED_MEASUREMENTS',
  ReadDeviceInfo = 'READ_DEVICE_INFO',
  ReadHourlyReports = 'READ_HOURLY_REPORTS',
  ReadMeasurementStream = 'READ_MEASUREMENT_STREAM'
}

export type IntermediaryUserTokenPayload = {
  __typename?: 'IntermediaryUserTokenPayload';
  accessToken: Scalars['String']['output'];
  user: UserInfo;
};

export type IntermediaryWebhookNotificationChannel = {
  __typename?: 'IntermediaryWebhookNotificationChannel';
  callbackUrl: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  type: NotificationChannelType;
};

export type IntermediaryWebhookSetting = {
  __typename?: 'IntermediaryWebhookSetting';
  id: Scalars['String']['output'];
};

export type InternalIdentity = IdentityBase & {
  __typename?: 'InternalIdentity';
  id: Scalars['String']['output'];
  type: IdentityType;
};

export enum Interval {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY'
}

export enum IntervalDuration {
  Hour = 'HOUR',
  QuarterHour = 'QUARTER_HOUR'
}

export type JedlixActiveNotificationsPayload = {
  __typename?: 'JedlixActiveNotificationsPayload';
  notifications: Array<Maybe<JedlixNotification>>;
};

export type JedlixAddress = {
  __typename?: 'JedlixAddress';
  city?: Maybe<Scalars['String']['output']>;
  country: CountryCode;
  houseNumber?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  priceArea?: Maybe<EnergyBiddingZone>;
  region?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type JedlixAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country: CountryCode;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export enum JedlixBrand {
  Abarth = 'ABARTH',
  Aiways = 'AIWAYS',
  Audi = 'AUDI',
  Bentley = 'BENTLEY',
  Bmw = 'BMW',
  Byd = 'BYD',
  Byton = 'BYTON',
  Cadillac = 'CADILLAC',
  Chevrolet = 'CHEVROLET',
  Citroen = 'CITROEN',
  Cupra = 'CUPRA',
  Dacia = 'DACIA',
  DrAutomobile = 'DR_AUTOMOBILE',
  Ds = 'DS',
  Fiat = 'FIAT',
  Fisker = 'FISKER',
  Ford = 'FORD',
  Genesis = 'GENESIS',
  Honda = 'HONDA',
  Hongqi = 'HONGQI',
  Hyundai = 'HYUNDAI',
  Jac = 'JAC',
  Jaguar = 'JAGUAR',
  Jeep = 'JEEP',
  Karma = 'KARMA',
  Kia = 'KIA',
  LandRover = 'LAND_ROVER',
  Levc = 'LEVC',
  Lexus = 'LEXUS',
  Lightyear = 'LIGHTYEAR',
  Lotus = 'LOTUS',
  Lucid = 'LUCID',
  LyncAndCo = 'LYNC_AND_CO',
  Maserati = 'MASERATI',
  Mazda = 'MAZDA',
  Mercedes = 'MERCEDES',
  Mg = 'MG',
  Mini = 'MINI',
  Mitsubishi = 'MITSUBISHI',
  Nio = 'NIO',
  Nissan = 'NISSAN',
  Opel = 'OPEL',
  Peugeot = 'PEUGEOT',
  Polestar = 'POLESTAR',
  Porsche = 'PORSCHE',
  Renault = 'RENAULT',
  RollsRoyce = 'ROLLS_ROYCE',
  Seat = 'SEAT',
  Seres = 'SERES',
  Skoda = 'SKODA',
  Smart = 'SMART',
  Sono = 'SONO',
  SsangYong = 'SSANG_YONG',
  Subaru = 'SUBARU',
  Suzuki = 'SUZUKI',
  Tesla = 'TESLA',
  Test = 'TEST',
  Toyota = 'TOYOTA',
  Vinfast = 'VINFAST',
  Volkswagen = 'VOLKSWAGEN',
  Volvo = 'VOLVO',
  Xpeng = 'XPENG'
}

export type JedlixChargeState = {
  __typename?: 'JedlixChargeState';
  batteryLevel: Scalars['Float']['output'];
  chargePower: Scalars['Float']['output'];
  chargingLocationId?: Maybe<Scalars['String']['output']>;
  chargingStatus: VehicleChargingStatus;
  range: Scalars['Float']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type JedlixChargingHistoryInput = {
  endTimeFrom: Scalars['Date']['input'];
  interval: Scalars['Int']['input'];
  startTimeTo: Scalars['Date']['input'];
  vehicleId: Scalars['String']['input'];
};

export type JedlixChargingHistoryLocation = {
  __typename?: 'JedlixChargingHistoryLocation';
  chargingLocationId: Scalars['String']['output'];
  country: CountryCode;
  priceArea?: Maybe<EnergyBiddingZone>;
};

export type JedlixChargingHistoryPayload = {
  __typename?: 'JedlixChargingHistoryPayload';
  chargingLocations: Array<Maybe<JedlixChargingHistoryLocation>>;
  chargingSessionsInInterval: Array<Maybe<ChargingSession>>;
};

export type JedlixChargingLocation = {
  __typename?: 'JedlixChargingLocation';
  address: JedlixAddress;
  coordinates: LatLng;
  id: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type JedlixChargingLocationInput = {
  chargingLocationId: Scalars['String']['input'];
};

export type JedlixChargingLocationPayload = {
  __typename?: 'JedlixChargingLocationPayload';
  chargingLocation: JedlixChargingLocation;
};

export type JedlixChargingLocationsPayload = {
  __typename?: 'JedlixChargingLocationsPayload';
  chargingLocations: Array<JedlixChargingLocation>;
};

export type JedlixConnection = {
  __typename?: 'JedlixConnection';
  id: Scalars['String']['output'];
  isFinished: Scalars['Boolean']['output'];
  redirectInfo?: Maybe<JedlixConnectionRedirectInfo>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  startUrl?: Maybe<Scalars['String']['output']>;
};

export type JedlixConnectionRedirectInfo = {
  __typename?: 'JedlixConnectionRedirectInfo';
  includeBody?: Maybe<Scalars['Boolean']['output']>;
  includeCookies: Array<Maybe<Scalars['String']['output']>>;
  includeRedirectUrl?: Maybe<Scalars['Boolean']['output']>;
};

export type JedlixNotification = {
  __typename?: 'JedlixNotification';
  createdAt: Scalars['Date']['output'];
  dismissedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  isDismissable: Scalars['Boolean']['output'];
  messageContext: Scalars['String']['output'];
  notificationType: JedlixNotificationType;
  title: Scalars['String']['output'];
  type: MessageType;
};

export enum JedlixNotificationType {
  Banner = 'BANNER',
  Email = 'EMAIL',
  PushNotification = 'PUSH_NOTIFICATION',
  Sms = 'SMS'
}

export type JedlixUserPayload = {
  __typename?: 'JedlixUserPayload';
  chargingLocations?: Maybe<Array<Maybe<JedlixChargingLocation>>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  locale: Scalars['String']['output'];
};

export type JedlixVehicle = {
  __typename?: 'JedlixVehicle';
  capabilities: VehicleCapabilities;
  chargeState?: Maybe<JedlixChargeState>;
  details?: Maybe<VehicleInfo>;
  id: Scalars['String']['output'];
  isConnectable: Scalars['Boolean']['output'];
  isConnected: Scalars['Boolean']['output'];
};

export type LatLng = {
  __typename?: 'LatLng';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type LatLngInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type ListJedlixVehiclesPayload = {
  __typename?: 'ListJedlixVehiclesPayload';
  vehicles: Array<Maybe<JedlixVehicle>>;
};

export type Location = {
  __typename?: 'Location';
  controllableIds: Array<Maybe<Scalars['String']['output']>>;
  coordinates: LatLng;
  deviceId?: Maybe<Scalars['String']['output']>;
  dso?: Maybe<DeliveryChargeModelId>;
  hourlyEnergyConsumptionLimit?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LocationAvailableConfiguredIntegrationVendorVehicleLocationState = {
  __typename?: 'LocationAvailableConfiguredIntegrationVendorVehicleLocationState';
  lastUpdatedAt: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  type: ConfiguredIntegrationVendorVehicleLocationStateType;
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginPayload = {
  __typename?: 'LoginPayload';
  session: SessionInfo;
  user: UserInfo;
};

export type Measurement = {
  __typename?: 'Measurement';
  /** Active energy exported, in Wh */
  activeEnergyExported?: Maybe<Scalars['Float']['output']>;
  /** Active energy imported, in Wh */
  activeEnergyImported?: Maybe<Scalars['Float']['output']>;
  /** Active power export, in W */
  activePowerExport?: Maybe<Scalars['Float']['output']>;
  /** Active power import, in W */
  activePowerImport?: Maybe<Scalars['Float']['output']>;
  /** Current, phase 1, in A */
  currentPhase1?: Maybe<Scalars['Float']['output']>;
  /** Current, phase 2, in A */
  currentPhase2?: Maybe<Scalars['Float']['output']>;
  /** Current, phase 3, in A */
  currentPhase3?: Maybe<Scalars['Float']['output']>;
  /** Reactive energy exported, in varh */
  reactiveEnergyExported?: Maybe<Scalars['Float']['output']>;
  /** Reactive energy imported, in varh */
  reactiveEnergyImported?: Maybe<Scalars['Float']['output']>;
  /** Reactive power export, in var */
  reactivePowerExport?: Maybe<Scalars['Float']['output']>;
  /** Reactive power import, in var */
  reactivePowerImport?: Maybe<Scalars['Float']['output']>;
  /** Time in UTC */
  time: Scalars['Date']['output'];
  /** Voltage, phase 1, in V */
  voltagePhase1?: Maybe<Scalars['Float']['output']>;
  /** Voltage, phase 2, in V */
  voltagePhase2?: Maybe<Scalars['Float']['output']>;
  /** Voltage, phase 3, in V */
  voltagePhase3?: Maybe<Scalars['Float']['output']>;
};

export enum MessageType {
  AudiNotPaired = 'AUDI_NOT_PAIRED',
  AudiPairingNotComplete = 'AUDI_PAIRING_NOT_COMPLETE',
  AudiRemoteAccessDisabled = 'AUDI_REMOTE_ACCESS_DISABLED',
  AudiRemoteAccessDisabledBanner = 'AUDI_REMOTE_ACCESS_DISABLED_BANNER',
  CarNotFound = 'CAR_NOT_FOUND',
  CarNotReachable = 'CAR_NOT_REACHABLE',
  CheckCarActivation = 'CHECK_CAR_ACTIVATION',
  EndSession = 'END_SESSION',
  GeoLocationDisabled = 'GEO_LOCATION_DISABLED',
  InvalidCredentials = 'INVALID_CREDENTIALS',
  InvalidCredentialsBanner = 'INVALID_CREDENTIALS_BANNER',
  InvalidUtilityContract = 'INVALID_UTILITY_CONTRACT',
  MyRenaultAccessRevoked = 'MY_RENAULT_ACCESS_REVOKED',
  ReadyForPairing = 'READY_FOR_PAIRING',
  ReceivedNoPower = 'RECEIVED_NO_POWER',
  ReconnectUtilityContract = 'RECONNECT_UTILITY_CONTRACT',
  SessionImpossible = 'SESSION_IMPOSSIBLE',
  StartSession = 'START_SESSION',
  ZeInteractiveExpiresSoon = 'ZE_INTERACTIVE_EXPIRES_SOON',
  ZeInteractiveToBeActivated = 'ZE_INTERACTIVE_TO_BE_ACTIVATED'
}

/** Metadata about our services */
export type Metadata = {
  __typename?: 'Metadata';
  /** Required version to run the app. The app should block the user from using an older version than this. */
  requiredAppVersion: Scalars['String']['output'];
  /** Suggested version to run the app. The app will present the user with information about expecting errors when running older versions of the app. */
  suggestedAppVersion: Scalars['String']['output'];
};

export enum MeterProducer {
  Aidon = 'AIDON',
  Embriq = 'EMBRIQ',
  Kaifa = 'KAIFA',
  Kamstrup = 'KAMSTRUP',
  Unrecognized = 'UNRECOGNIZED'
}

export type MillSignInInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MillSignInPayload = {
  __typename?: 'MillSignInPayload';
  success: Scalars['Boolean']['output'];
};

export enum Month {
  April = 'APRIL',
  August = 'AUGUST',
  December = 'DECEMBER',
  February = 'FEBRUARY',
  January = 'JANUARY',
  July = 'JULY',
  June = 'JUNE',
  March = 'MARCH',
  May = 'MAY',
  November = 'NOVEMBER',
  October = 'OCTOBER',
  September = 'SEPTEMBER'
}

export type MonthRange = {
  __typename?: 'MonthRange';
  /** 1-12, including start */
  from: Scalars['Int']['output'];
  /** 1-12, exluding end */
  until: Scalars['Int']['output'];
};

export type MonthWeights = {
  __typename?: 'MonthWeights';
  april: Scalars['Float']['output'];
  august: Scalars['Float']['output'];
  december: Scalars['Float']['output'];
  february: Scalars['Float']['output'];
  january: Scalars['Float']['output'];
  july: Scalars['Float']['output'];
  june: Scalars['Float']['output'];
  march: Scalars['Float']['output'];
  may: Scalars['Float']['output'];
  november: Scalars['Float']['output'];
  october: Scalars['Float']['output'];
  september: Scalars['Float']['output'];
};

/**
 * Capacity model where (e.g. 3) daily maximas for a month is averaged and used to
 * determine the capacity step. The steps has a range in Wh with a price, and
 * there is also a field defining the price for when all capacity steps are
 * exceeded.
 */
export type MonthlyPeaksAtDifferentDays = {
  __typename?: 'MonthlyPeaksAtDifferentDays';
  capacitySteps: Array<CapacityStep>;
  peaksPerMonth: Scalars['Int']['output'];
  priceAboveCapacitySteps: PriceSpecification;
  type: CapacityModelType;
};

/**
 * Capacity model where (e.g. 3) daily maximas for a month is averaged and used to
 * determine the capacity step. The steps has a range in Wh with a price, and
 * there is also a field defining the price for when all capacity steps are
 * exceeded.
 *
 * Includes a yearly energy fund fee.
 */
export type MonthlyPeaksAtDifferentDaysBusiness = {
  __typename?: 'MonthlyPeaksAtDifferentDaysBusiness';
  capacitySteps: Array<CapacityStep>;
  peaksPerMonth: Scalars['Int']['output'];
  priceAboveCapacitySteps: PriceSpecification;
  type: CapacityModelBusinessType;
  yearlyEnergyFund: PriceSpecification;
};

/**
 * Capacity model where (e.g. 3) daily maximas for a month is averaged and
 * multiplied by `pricePerKwhForAverageOfPeaks` and added to `baseFeePerYear`.
 *
 * Capacity model used by SkiakerNett, but with only one maxima.
 *
 * <https://skiakernett.no/nettleige/>
 */
export type MonthlyPeaksAtDifferentDaysLinearWithBase = {
  __typename?: 'MonthlyPeaksAtDifferentDaysLinearWithBase';
  baseFeePerYear: PriceSpecification;
  /** The number of daily peaks that will be averaged to find the capacity step. */
  peaksPerMonth: Scalars['Int']['output'];
  pricePerKwhForAverageOfPeaks: PriceSpecification;
  type: CapacityModelType;
};

export type MonthlyPriceSpecification = {
  __typename?: 'MonthlyPriceSpecification';
  monthlyPrice: PriceSpecification;
};

export type Mutation = {
  __typename?: 'Mutation';
  addBrightNotificationChannelToAlertSetting: AddBrightNotificationChanneltToAlertSettingPayload;
  addChargingLocation: AddChargingLocationPayload;
  addChargingPermission?: Maybe<AddChargingPermissionPayload>;
  addControllableForLocation: AddControllableForLocationPayload;
  /** Add device permissions to a user. */
  addDevicePermissions?: Maybe<AddDevicePermissionsPayload>;
  addDeviceToken?: Maybe<Scalars['Void']['output']>;
  /** Add a dynamic alert that continuously evaluates whether the device has crossed a set limit for energy consumption within the hour. */
  addEstimatedHourlyActiveEnergyLimitWarningAlertSetting: EstimatedHourlyActiveEnergyLimitWarningAlertSetting;
  /** Add an alert that is evaluated 30 minutes into the hour and checks if the device's energy consumption is about to exceed a set limit. */
  addHourlyConsumptionLimitEstimationWarningAlertSetting: HourlyConsumptionLimitEstimationWarningAlertSetting;
  addIntermediaryApiKey: IntermediaryApiKeyPayload;
  addIntermediaryWebhookNotificationChannelToAlertSetting: AddIntermediaryWebhookNotificationChannelToAlertSettingPayload;
  /** Add Location */
  addLocation: AddLocationPayload;
  addPriceWarningAlertSetting: PriceWarningAlertSetting;
  addPushNotificationChannelToAlertSetting: AddPushNotificationChannelToAlertSettingPayload;
  /** Create a user using an external user identifier of your choice. */
  addUser: AddUserPayload;
  /** Create an access token for a user. */
  addUserSession: AddUserSessionPayload;
  /** Cancel an Order */
  cancelOrder: Order;
  claimDevice: DeviceInfo;
  commonSignIn: CommonSignInPayload;
  /** @deprecated Deprecated. Please use ordersForUser, addUser, addDevicePermissions, and addUserSession individually instead. */
  connectExternalUser: ConnectExternalUserPayload;
  connectJedlixVehicle: JedlixConnection;
  /** Create charge settings for a user's vehicle. */
  createChargeSettings: CreateChargeSettingsPayload;
  createDevice: DeviceInfo;
  createJedlixChargingLocation: JedlixChargingLocation;
  createJedlixUser: JedlixUserPayload;
  deleteAlertSetting: DeleteAlertSettingPayload;
  deleteChargingLocation: DeleteChargingLocationPayload;
  deleteDeviceName?: Maybe<DeviceInfo>;
  deleteJedlixChargingLocation?: Maybe<DeleteJedlixChargingLocationPayload>;
  deleteJedlixUser?: Maybe<DeleteJedlixUserPayload>;
  deleteJedlixVehicle?: Maybe<DeleteJedlixVehiclePayload>;
  deleteMe: DeleteMePayload;
  disconnectVendor: DisconnectVendorPayload;
  grantDeviceAccess: Permission;
  login: LoginPayload;
  millSignIn?: Maybe<MillSignInPayload>;
  /** Order a device */
  orderDevice: OrderDevicePayload;
  processOrderForIntermediary?: Maybe<ProcessOrderForIntermediaryPayload>;
  /**
   * Refurbish a device.
   *
   * This mutation is only available for internal use. It is used to update the state of a device that has been refurbished.
   */
  refurbishDevice: RefurbishDevicePayload;
  register?: Maybe<Scalars['Boolean']['output']>;
  removeChargingPermission?: Maybe<RemoveChargingPermissionPayload>;
  removeControllableFromLocation: RemoveControllableFromLocationPayload;
  /** Remove device permissions from a user. */
  removeDevicePermissions?: Maybe<RemoveDevicePermissionsPayload>;
  removeDeviceToken?: Maybe<Scalars['Void']['output']>;
  removeIntermediaryApiKey: IntermediaryApiKeyPayload;
  /** Remove Location */
  removeLocation: RemoveLocationPayload;
  removeNotificationChannelFromAlertSetting: RemoveNotificationChannelFromAlertSettingPayload;
  /** Remove a user from the system. */
  removeUser: RemoveUserPayload;
  returnDevice: ReturnDevicePayload;
  revokeDeviceAccess?: Maybe<Scalars['Boolean']['output']>;
  sendEmailVerificationEmail?: Maybe<Scalars['Boolean']['output']>;
  sendResetPasswordEmail?: Maybe<Scalars['Boolean']['output']>;
  setCoordinatesForLocation: SetCoordinatesForLocationPayload;
  setDeviceActivationStatus: SetDeviceActivationStatusPayload;
  setDeviceForLocation: SetDeviceForLocationPayload;
  setEnergyConsumptionLimitForLocation: SetEnergyConsumptionLimitForLocationPayload;
  setIntermediaryWebhookSetting: SetIntermediaryWebhookSettingPayload;
  setNameForLocation: SetNameForLocationPayload;
  shipDevice: DeviceInfo;
  shipOrder: Order;
  startIntegrationSession: IntegrationSessionPayload;
  startOperationalCheck: StartOperationalCheckPayload;
  testWebhookSetting: TestWebhookSettingPayload;
  /** Update an existing user's vehicle charge settings. */
  updateChargeSettings: UpdateChargeSettingsPayload;
  updateChargingLocation: UpdateChargingLocationPayload;
  /**
   * Update device metadata info. When running jig config/setup/calibration a second time, this endpoint should be used.
   * The input and output is similar to createDevice.
   */
  updateDeviceMetadata?: Maybe<DeviceInfo>;
  /**
   * Updates the device name
   *
   * Since the `deviceName` input is mandatory, there is another mutation to delete the device name.
   */
  updateDeviceName?: Maybe<DeviceInfo>;
  /**
   * Update device owner information. Will not change the info about who the device was shipped to.
   *
   * `deviceOwner` will be replaced by the new input object, and missing fields will be removed.
   */
  updateDeviceOwner?: Maybe<DeviceInfo>;
  /** Update the limit for when an alert should be triggered for the dynamic alert. */
  updateEstimatedHourlyActiveEnergyLimitWarningAlertSetting: UpdateEstimatedHourlyActiveEnergyLimitWarningAlertSettingPayload;
  /** Update the limit for when an alert should be triggered for the half-hour alert. */
  updateHourlyConsumptionLimitEstimationWarningAlertSetting: UpdateHourlyConsumptionLimitEstimationWarningAlertSettingPayload;
  updateJedlixChargingLocation: JedlixChargingLocation;
  updatePreferredEnergyBiddingZone?: Maybe<Scalars['Boolean']['output']>;
  updateSmartChargingPolicy: UpdateSmartChargingPolicyPayload;
  zaptecClaimInstallation: ZaptecClaimInstallationPayload;
};


export type MutationAddBrightNotificationChannelToAlertSettingArgs = {
  input: AddBrightNotificationChannelToAlertSettingInput;
};


export type MutationAddChargingLocationArgs = {
  input: AddChargingLocationInput;
};


export type MutationAddChargingPermissionArgs = {
  input: AddChargingPermissionInput;
};


export type MutationAddControllableForLocationArgs = {
  input: AddControllableForLocationInput;
};


export type MutationAddDevicePermissionsArgs = {
  input: AddDevicePermissionsInput;
};


export type MutationAddDeviceTokenArgs = {
  deviceToken: Scalars['String']['input'];
};


export type MutationAddEstimatedHourlyActiveEnergyLimitWarningAlertSettingArgs = {
  input: AddEstimatedHourlyActiveEnergyLimitWarningAlertSettingInput;
};


export type MutationAddHourlyConsumptionLimitEstimationWarningAlertSettingArgs = {
  input: AddHourlyConsumptionLimitEstimationWarningAlertSettingInput;
};


export type MutationAddIntermediaryApiKeyArgs = {
  input: AddIntermediaryApiKeyInput;
};


export type MutationAddIntermediaryWebhookNotificationChannelToAlertSettingArgs = {
  input: AddIntermediaryWebhookNotificationChannelToAlertSettingInput;
};


export type MutationAddLocationArgs = {
  input: AddLocationInput;
};


export type MutationAddPriceWarningAlertSettingArgs = {
  input: AddPriceWarningAlertSettingInput;
};


export type MutationAddPushNotificationChannelToAlertSettingArgs = {
  input: AddPushNotificationChannelToAlertSettingInput;
};


export type MutationAddUserArgs = {
  input: AddUserInput;
};


export type MutationAddUserSessionArgs = {
  input: AddUserSessionInput;
};


export type MutationCancelOrderArgs = {
  input: CancelOrderInput;
};


export type MutationClaimDeviceArgs = {
  claimId: Scalars['ClaimId']['input'];
};


export type MutationCommonSignInArgs = {
  input: CommonSignInInput;
};


export type MutationConnectExternalUserArgs = {
  input: ConnectExternalUserInput;
};


export type MutationConnectJedlixVehicleArgs = {
  input?: InputMaybe<Scalars['Void']['input']>;
};


export type MutationCreateChargeSettingsArgs = {
  input: CreateChargeSettingsInput;
};


export type MutationCreateDeviceArgs = {
  input: DeviceInput;
};


export type MutationCreateJedlixChargingLocationArgs = {
  input: CreateJedlixChargingLocationInput;
};


export type MutationCreateJedlixUserArgs = {
  input: CreateJedlixUserInput;
};


export type MutationDeleteAlertSettingArgs = {
  input: DeleteAlertSettingInput;
};


export type MutationDeleteChargingLocationArgs = {
  input: DeleteChargingLocationInput;
};


export type MutationDeleteDeviceNameArgs = {
  deviceId: Scalars['String']['input'];
};


export type MutationDeleteJedlixChargingLocationArgs = {
  input: DeleteJedlixChargingLocationInput;
};


export type MutationDeleteJedlixUserArgs = {
  input: Scalars['Void']['input'];
};


export type MutationDeleteJedlixVehicleArgs = {
  input: DeleteJedlixVehicleInput;
};


export type MutationDeleteMeArgs = {
  input: DeleteMeInput;
};


export type MutationDisconnectVendorArgs = {
  input: DisconnectVendorInput;
};


export type MutationGrantDeviceAccessArgs = {
  input: GrantDeviceAccessInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationMillSignInArgs = {
  input: MillSignInInput;
};


export type MutationOrderDeviceArgs = {
  input: OrderDeviceInput;
};


export type MutationProcessOrderForIntermediaryArgs = {
  input: ProcessOrderForIntermediaryInput;
};


export type MutationRefurbishDeviceArgs = {
  input: RefurbishDeviceInput;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationRemoveChargingPermissionArgs = {
  input: RemoveChargingPermissionInput;
};


export type MutationRemoveControllableFromLocationArgs = {
  input: RemoveControllableFromLocationInput;
};


export type MutationRemoveDevicePermissionsArgs = {
  input: RemoveDevicePermissionsInput;
};


export type MutationRemoveDeviceTokenArgs = {
  deviceToken: Scalars['String']['input'];
};


export type MutationRemoveIntermediaryApiKeyArgs = {
  input: RemoveIntermediaryApiKeyInput;
};


export type MutationRemoveLocationArgs = {
  input: RemoveLocationInput;
};


export type MutationRemoveNotificationChannelFromAlertSettingArgs = {
  input: RemoveNotificationChannelFromAlertSettingInput;
};


export type MutationRemoveUserArgs = {
  input: RemoveUserInput;
};


export type MutationReturnDeviceArgs = {
  input: ReturnDeviceInput;
};


export type MutationRevokeDeviceAccessArgs = {
  input: RevokeDeviceAccessInput;
};


export type MutationSendEmailVerificationEmailArgs = {
  input: EmailActionInput;
};


export type MutationSendResetPasswordEmailArgs = {
  input: EmailActionInput;
};


export type MutationSetCoordinatesForLocationArgs = {
  input: SetCoordinatesForLocationInput;
};


export type MutationSetDeviceActivationStatusArgs = {
  input: SetDeviceActivationStatusInput;
};


export type MutationSetDeviceForLocationArgs = {
  input: SetDeviceForLocationInput;
};


export type MutationSetEnergyConsumptionLimitForLocationArgs = {
  input: SetEnergyConsumptionLimitForLocationInput;
};


export type MutationSetIntermediaryWebhookSettingArgs = {
  input: SetIntermediaryWebhookSettingInput;
};


export type MutationSetNameForLocationArgs = {
  input: SetNameForLocationInput;
};


export type MutationShipDeviceArgs = {
  deviceIdentifier: ShipDeviceIdentifierInput;
  intermediaryId: Scalars['String']['input'];
  shipTo?: InputMaybe<ShipToUserInput>;
  subscription: SubscriptionInput;
  webhookCallbackUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationShipOrderArgs = {
  input: ShipOrderInput;
};


export type MutationStartIntegrationSessionArgs = {
  input: IntegrationSessionInput;
};


export type MutationStartOperationalCheckArgs = {
  input: StartOperationalCheckInput;
};


export type MutationTestWebhookSettingArgs = {
  input: TestWebhookSettingInput;
};


export type MutationUpdateChargeSettingsArgs = {
  input: UpdateChargeSettingsInput;
};


export type MutationUpdateChargingLocationArgs = {
  input: UpdateChargingLocationInput;
};


export type MutationUpdateDeviceMetadataArgs = {
  input: DeviceInput;
};


export type MutationUpdateDeviceNameArgs = {
  deviceId: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
};


export type MutationUpdateDeviceOwnerArgs = {
  deviceId: Scalars['String']['input'];
  deviceOwner: DeviceOwnerInput;
};


export type MutationUpdateEstimatedHourlyActiveEnergyLimitWarningAlertSettingArgs = {
  input: UpdateEstimatedHourlyActiveEnergyLimitWarningAlertSettingInput;
};


export type MutationUpdateHourlyConsumptionLimitEstimationWarningAlertSettingArgs = {
  input: UpdateHourlyConsumptionLimitEstimationWarningAlertSettingInput;
};


export type MutationUpdateJedlixChargingLocationArgs = {
  input: UpdateJedlixChargingLocationInput;
};


export type MutationUpdatePreferredEnergyBiddingZoneArgs = {
  deviceId: Scalars['String']['input'];
  preferredEnergyBiddingZone: EnergyBiddingZone;
};


export type MutationUpdateSmartChargingPolicyArgs = {
  input: UpdateSmartChargingPolicyInput;
};


export type MutationZaptecClaimInstallationArgs = {
  input: ZaptecClaimInstallationInput;
};

export type MyDevicesInput = {
  filter?: InputMaybe<DeviceFilter>;
};

export type NotConfiguredIntegrationVendorInfo = {
  __typename?: 'NotConfiguredIntegrationVendorInfo';
  status: IntegrationVendorStatus;
  vendor: IntegrationVendor;
};

export type NotificationChannel = BrightNotificationChannel | IntermediaryWebhookNotificationChannel | PushNotificationChannel;

export enum NotificationChannelType {
  BrightNotification = 'BRIGHT_NOTIFICATION',
  IntermediaryWebhook = 'INTERMEDIARY_WEBHOOK',
  PushNotification = 'PUSH_NOTIFICATION'
}

export enum NotificationType {
  PriceWarning = 'PRICE_WARNING'
}

export type OptionalFieldsPostalAddress = {
  __typename?: 'OptionalFieldsPostalAddress';
  country?: Maybe<PostcodeCountry>;
  postcode?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
};

export type OptionalFieldsPostalAddressInput = {
  country?: InputMaybe<PostcodeCountry>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
};

export type Order = {
  __typename?: 'Order';
  deviceId?: Maybe<Scalars['String']['output']>;
  intermediaryId: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderStatus: OrderStatus;
  recipient: PostalRecipient;
  subscriptionType: OrderSubscriptionType;
  trackingLink?: Maybe<Scalars['String']['output']>;
  type: DeviceType;
  updatedAt: Scalars['Date']['output'];
  webhookCallbackUrl?: Maybe<Scalars['String']['output']>;
};

export type OrderDeviceInput = {
  /** The person to whom the device should be shipped */
  recipient: PostalRecipientInput;
  subscriptionType: OrderSubscriptionType;
  type: DeviceType;
  /** The URL to which the webhook should be sent when the order status is changed */
  webhookCallbackUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OrderDevicePayload = {
  __typename?: 'OrderDevicePayload';
  order: Order;
  ordersForUser: Array<Maybe<Order>>;
};

export type OrderInput = {
  orderId: Scalars['String']['input'];
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  InProgress = 'IN_PROGRESS',
  Ordered = 'ORDERED',
  Shipped = 'SHIPPED'
}

export enum OrderSubscriptionType {
  Business = 'BUSINESS',
  Personal = 'PERSONAL'
}

export type OrderSummary = {
  __typename?: 'OrderSummary';
  intermediaryId: Scalars['String']['output'];
  ltemsToBeShipped: Scalars['Int']['output'];
  wifisToBeShipped: Scalars['Int']['output'];
};

export type OrderSummaryPayload = {
  __typename?: 'OrderSummaryPayload';
  orderSummary: Array<Maybe<OrderSummary>>;
};

export type OrdersForUserInput = {
  externalUserId: Scalars['String']['input'];
};

export type OrdersForUserPayload = {
  __typename?: 'OrdersForUserPayload';
  orders: Array<Order>;
};

/** User information for device owners */
export type OwnedByUserInfo = {
  __typename?: 'OwnedByUserInfo';
  emailAddress?: Maybe<Scalars['String']['output']>;
  externalUserId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalAddress?: Maybe<OptionalFieldsPostalAddress>;
};

/** The fixed part is given as price per month */
export type PerMonthFixedFee = {
  __typename?: 'PerMonthFixedFee';
  pricePerMonth: PriceSpecification;
  yearlyEnergyFund: PriceSpecification;
};

/**
 * The fixed part divides a yearly price by days of the year and multiplies this
 * by days of the month
 */
export type PerYearDividedByDaysFixedFee = {
  __typename?: 'PerYearDividedByDaysFixedFee';
  pricePerYear: PriceSpecification;
  yearlyEnergyFund: PriceSpecification;
};

/** Our permission system works across different types of resources and different types of actors */
export type Permission = {
  __typename?: 'Permission';
  /** The id of the entity being permitted, e.g. a userId */
  entityId: Scalars['String']['output'];
  /** The id of the resource the permission is targeting, e.g. a deviceId */
  resourceId: Scalars['String']['output'];
  /** Permissions to resources, like read or write, are defined by scopes */
  scopes: Array<Scalars['String']['output']>;
};

export type PhasePrices = {
  __typename?: 'PhasePrices';
  /** Prices for 230V networks */
  voltage230: PhaseVoltagePrices;
  /** Prices for 400V networks */
  voltage400: PhaseVoltagePrices;
};

export type PhaseVoltagePrices = {
  __typename?: 'PhaseVoltagePrices';
  currentRangePrices: Array<CurrentRangePrice>;
  yearlyPriceAboveCurrentRanges: PriceSpecification;
};

export type PlannedSmartChargingStatus = {
  __typename?: 'PlannedSmartChargingStatus';
  externalStart: Scalars['Boolean']['output'];
  plan: SmartChargingPlan;
  planningStatus: SmartChargingPlanningStatusType;
  type: SmartChargingStatusType;
};

export type PostalAddress = {
  __typename?: 'PostalAddress';
  country: PostcodeCountry;
  postcode: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
};

export type PostalAddressInput = {
  country: PostcodeCountry;
  postcode: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
};

export type PostalRecipient = {
  __typename?: 'PostalRecipient';
  email: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  postalAddress: PostalRecipientPostalAddress;
};

export type PostalRecipientInput = {
  /** Max-length 60 characters */
  email: Scalars['String']['input'];
  externalUserId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  postalAddress: PostalRecipientPostalAddressInput;
};

export type PostalRecipientPostalAddress = {
  __typename?: 'PostalRecipientPostalAddress';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: CountryCode;
  postalCode: Scalars['String']['output'];
};

export type PostalRecipientPostalAddressInput = {
  /** Max-length 35 characters */
  addressLine1: Scalars['String']['input'];
  /** Max-length 35 characters */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Max-length 35 characters */
  city: Scalars['String']['input'];
  country: CountryCode;
  /** 4 digits if country is Norway */
  postalCode: Scalars['String']['input'];
};

export enum PostcodeCountry {
  Norway = 'NORWAY'
}

export type PowerRangeInKw = {
  __typename?: 'PowerRangeInKw';
  /** From, inclusive */
  from: Scalars['Int']['output'];
  /** Until, exclusive */
  until: Scalars['Int']['output'];
};

export type PriceSpecification = {
  __typename?: 'PriceSpecification';
  /** The actual price, this should be including VAT (MVA) where it applies */
  price: Scalars['Float']['output'];
  /** The currency of the given price, usually in NOK */
  priceCurrency: Currency;
  /** The prices without VAT (MVA) */
  priceExcludingVat: Scalars['Float']['output'];
  /** VAT, or "Merverdiavgift" */
  vat: Scalars['Float']['output'];
};

export type PriceWarningAlertSetting = {
  __typename?: 'PriceWarningAlertSetting';
  alertType: AlertType;
  createdBy: AlertSettingCreator;
  energyBiddingZone: EnergyBiddingZone;
  id: Scalars['ID']['output'];
  notificationChannels: Array<NotificationChannel>;
};

/** An event type that is used if PriceWarningAlertSetting was triggered. */
export type PriceWarningEvent = {
  __typename?: 'PriceWarningEvent';
  alertSettingId: Scalars['String']['output'];
  alertType: SentAlertAlertType;
  at: Scalars['Date']['output'];
  energyBiddingZone: EnergyBiddingZone;
  intermediaryId?: Maybe<Scalars['String']['output']>;
  notificationChannelType: NotificationChannelType;
  type: AlertEventType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type PriceWarningPushNotificationSetting = {
  __typename?: 'PriceWarningPushNotificationSetting';
  deviceId: Scalars['String']['output'];
  notificationType: NotificationType;
  wantsNotification: Scalars['Boolean']['output'];
};

export type PriceZone = {
  __typename?: 'PriceZone';
  zone: EnergyBiddingZone;
};

export type PriceZoneInput = {
  addressInput?: InputMaybe<AddressInput>;
  latLngInput?: InputMaybe<LatLngInput>;
};

/** Prices and taxes type */
export type PricesAndTaxes = {
  __typename?: 'PricesAndTaxes';
  priceExcludingEnergyTaxes: PriceSpecification;
  priceIncludingEnergyTaxes: PriceSpecification;
  taxes: DeliveryChargeEnergyTaxes;
};

/** Prices and taxes for business */
export type PricesAndTaxesBusiness = {
  __typename?: 'PricesAndTaxesBusiness';
  priceExcludingEnergyTaxes: PriceSpecification;
  priceIncludingEnergyTaxes: PriceSpecification;
  taxes: DeliveryChargeEnergyTaxesBusiness;
};

/**
 * Price and tax info for part of a day, includes a specification of which hours
 * the price is for.
 */
export type PricesAndTaxesForPartOfDay = {
  __typename?: 'PricesAndTaxesForPartOfDay';
  hours: HourRange;
  pricesAndTaxes: PricesAndTaxes;
};

/**
 * Price and tax info for part of a day, includes a specification of which hours
 * the price is for.
 */
export type PricesAndTaxesForPartOfDayBusiness = {
  __typename?: 'PricesAndTaxesForPartOfDayBusiness';
  hours: HourRange;
  pricesAndTaxes: PricesAndTaxesBusiness;
};

/**
 * The prices for a part of year, will include the price specifiations and a
 * for what months the prices is for
 */
export type PricesForPartOfYear = {
  __typename?: 'PricesForPartOfYear';
  months: MonthRange;
  prices: DayAndNightPrices;
};

/**
 * The prices for a part of year, will include the price specifiations and a
 * for what months the prices is for
 */
export type PricesForPartOfYearBusiness = {
  __typename?: 'PricesForPartOfYearBusiness';
  months: MonthRange;
  prices: DayAndNightPricesBusiness;
};

/**
 * The prices for a part of year without differentiating day and night, will include the price specifications and a
 * for what months the prices is for
 */
export type PricesForPartOfYearWithoutDayAndNight = {
  __typename?: 'PricesForPartOfYearWithoutDayAndNight';
  months: MonthRange;
  /** @deprecated The field is not complete, use the adjacent field `pricesAndTaxes` */
  price: PriceSpecification;
  pricesAndTaxes: PricesAndTaxes;
};

/**
 * The prices for a part of year without differentiating day and night, will include the price specifiations and a
 * for what months the prices is for
 */
export type PricesForPartOfYearWithoutDayAndNightBusiness = {
  __typename?: 'PricesForPartOfYearWithoutDayAndNightBusiness';
  months: MonthRange;
  pricesAndTaxes: PricesAndTaxesBusiness;
};

export type ProcessOrderForIntermediaryInput = {
  deviceType: DeviceType;
  intermediaryId: Scalars['String']['input'];
};

export type ProcessOrderForIntermediaryPayload = {
  __typename?: 'ProcessOrderForIntermediaryPayload';
  order?: Maybe<Order>;
};

export type PushNotificationChannel = {
  __typename?: 'PushNotificationChannel';
  forUserWithId: Scalars['String']['output'];
  type: NotificationChannelType;
};

export type PushNotificationSetting = PriceWarningPushNotificationSetting;

export type Query = {
  __typename?: 'Query';
  /** Gets the alert events for the last 30 days. */
  alertEvents: AlertEventsPayload;
  alertEventsOfChannelType: AlertEventsOfChannelTypePayload;
  bigQueryMeasurements: Array<Measurement>;
  chargingStatistics: ChargingStatisticsPayload;
  checkJedlixConnection: JedlixConnection;
  currentIntermediary: CurrentIntermediaryPayload;
  /**
   * Day ahead prices
   *
   * Get price data from the Entso-E transparency platrom for the time range
   * specified.
   *
   * Prices are converted to NOK and VAT is added for the zones where
   * this is applicable.
   *
   * Read more about the transparency platform of the European Network of
   * Transmission System Operators at https://transparency.entsoe.eu/
   */
  dayAheadPrices: Array<Maybe<EnergyPriceOfHour>>;
  deliveryChargeArea?: Maybe<DeliveryChargeArea>;
  deliveryChargeCost: DeliveryChargeCost;
  deliveryChargeCostBusiness: DeliveryChargeCostBusiness;
  deliveryChargeCostEnterprise: DeliveryChargeCostEnterprise;
  /** Get the delivery charge model for a DSO in the private segment */
  deliveryChargeModel: DeliveryChargeModel;
  /** Get the delivery charge model for a DSO in the business segment */
  deliveryChargeModelBusiness: DeliveryChargeModelBusiness;
  /** Get the delivery charge model for a DSO in the enterprise/industry segment */
  deliveryChargeModelEnterprise: DeliveryChargeModelEnterprise;
  device: DeviceQueryPayload;
  electricalPowerTaxes: ElectricalPowerTaxes;
  energyFundTaxes: EnergyFundTaxes;
  /** Get charge settings for a Jedlix user's vehicle. */
  getChargeSettings: GetChargeSettingsPayload;
  /** Generates an authorization URL which can be embedded in a webview which in turn will allow an end user to grant our API access to control their vehicle/charger */
  integrationAuthorizationUrl: IntegrationAuthorizationUrlResponse;
  jedlixActiveNotifications: JedlixActiveNotificationsPayload;
  jedlixChargingHistory: JedlixChargingHistoryPayload;
  jedlixChargingLocation: JedlixChargingLocationPayload;
  jedlixChargingLocations: JedlixChargingLocationsPayload;
  jedlixUser: JedlixUserPayload;
  listControllablesForUser: ControllablesForUserPayload;
  listJedlixVehicles: ListJedlixVehiclesPayload;
  /** Get Locations */
  locations: Array<Location>;
  me: UserInfo;
  /**
   * Get data from the latest measurements using deviceId or meterId (or both)
   *
   * * If only deviceId is given, reports for the most recent meterId that the device was connected to in the requested range will be returned
   * * If only meterId is given, reports for this meter will be returned from the most recent deviceId that was connected to this meter in the requested range
   * * If both meterId and deviceId is given, reports will only be returned if the given deviceId was connected to the given meterId in the requested range
   *
   * In all cases the accessToken needs permissions to read reports for the corresponding deviceId.
   *
   * Measurements are only available for two to three hours.
   */
  measurements: Array<Measurement>;
  /** Get metadata about services, like minimum required app requiredAppVersion */
  metadata: Metadata;
  myDevices: Array<DeviceInfo>;
  /** Get an Order by its Id */
  order: Order;
  orderSummary: OrderSummaryPayload;
  /** Get all Orders for a given user */
  ordersForUser: OrdersForUserPayload;
  /** Get permissions containing requested scopes for the authenticated user */
  permissions: Array<Permission>;
  priceZone?: Maybe<PriceZone>;
  /**
   * Get hourly or daily reports using deviceId or meterId (or both)
   *
   * * If only deviceId is given, reports for the most recent meterId that the device was connected to in the requested range will be returned
   * * If only meterId is given, reports for this meter will be returned from the most recent deviceId that was connected to this meter in the requested range
   * * If both meterId and deviceId is given, reports will only be returned if the given deviceId was connected to the given meterId in the requested range
   *
   * In all cases the accessToken needs permissions to read reports for the corresponding deviceId.
   */
  reports: Array<Report>;
  user: UserPayload;
  vehicleSmartChargingStatus: VehicleSmartChargingStatusPayload;
};


export type QueryAlertEventsOfChannelTypeArgs = {
  input: AlertEventsOfChannelTypeInput;
};


export type QueryBigQueryMeasurementsArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['String']['input'];
  meterId?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};


export type QueryChargingStatisticsArgs = {
  input: ChargingStatisticsInput;
};


export type QueryCheckJedlixConnectionArgs = {
  input: CheckJedlixConnectionInput;
};


export type QueryDayAheadPricesArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  zone: EnergyBiddingZone;
};


export type QueryDeliveryChargeAreaArgs = {
  input: DeliveryChargeAreaInput;
};


export type QueryDeliveryChargeCostArgs = {
  input: DeliveryChargeCostInput;
};


export type QueryDeliveryChargeCostBusinessArgs = {
  input: DeliveryChargeCostBusinessInput;
};


export type QueryDeliveryChargeCostEnterpriseArgs = {
  input: DeliveryChargeCostEnterpriseInput;
};


export type QueryDeliveryChargeModelArgs = {
  input: DeliveryChargeModelInput;
};


export type QueryDeliveryChargeModelBusinessArgs = {
  input: DeliveryChargeModelBusinessInput;
};


export type QueryDeliveryChargeModelEnterpriseArgs = {
  input: DeliveryChargeModelInput;
};


export type QueryDeviceArgs = {
  input: DeviceQueryInput;
};


export type QueryElectricalPowerTaxesArgs = {
  input: ElectricalPowerTaxesInput;
};


export type QueryEnergyFundTaxesArgs = {
  input: EnergyFundTaxesInput;
};


export type QueryGetChargeSettingsArgs = {
  input: GetChargeSettingsInput;
};


export type QueryIntegrationAuthorizationUrlArgs = {
  input: IntegrationAuthorizationUrlInput;
};


export type QueryJedlixActiveNotificationsArgs = {
  input?: InputMaybe<Scalars['Void']['input']>;
};


export type QueryJedlixChargingHistoryArgs = {
  input: JedlixChargingHistoryInput;
};


export type QueryJedlixChargingLocationArgs = {
  input: JedlixChargingLocationInput;
};


export type QueryJedlixChargingLocationsArgs = {
  input?: InputMaybe<Scalars['Void']['input']>;
};


export type QueryJedlixUserArgs = {
  input: Scalars['Void']['input'];
};


export type QueryListControllablesForUserArgs = {
  input?: InputMaybe<Scalars['Void']['input']>;
};


export type QueryListJedlixVehiclesArgs = {
  input?: InputMaybe<Scalars['Void']['input']>;
};


export type QueryMeasurementsArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['String']['input'];
  meterId?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};


export type QueryMyDevicesArgs = {
  input?: InputMaybe<MyDevicesInput>;
};


export type QueryOrderArgs = {
  input: OrderInput;
};


export type QueryOrderSummaryArgs = {
  input?: InputMaybe<Scalars['Void']['input']>;
};


export type QueryOrdersForUserArgs = {
  input: OrdersForUserInput;
};


export type QueryPermissionsArgs = {
  scopes: Array<Scalars['String']['input']>;
};


export type QueryPriceZoneArgs = {
  input: PriceZoneInput;
};


export type QueryReportsArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['String']['input'];
  interval: Interval;
  meterId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Timezone>;
  to: Scalars['String']['input'];
};


export type QueryUserArgs = {
  input: UserInput;
};


export type QueryVehicleSmartChargingStatusArgs = {
  input: VehicleSmartChargingStatusInput;
};

export type Range = {
  __typename?: 'Range';
  max: Scalars['Float']['output'];
  mean: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type RecentMeter = {
  __typename?: 'RecentMeter';
  firstSeenAt: Scalars['Date']['output'];
  meterId: Scalars['MeterId']['output'];
  producer: MeterProducer;
  shortMeterId: Scalars['String']['output'];
};

export type RefurbishDeviceInput = {
  deviceId: Scalars['String']['input'];
  parts: RefurbishDevicePartsInput;
  refurbishId?: InputMaybe<Scalars['String']['input']>;
};

export type RefurbishDevicePartsInput = {
  backCasingOk: Scalars['Boolean']['input'];
  boxDeviceLabelOk: Scalars['Boolean']['input'];
  cardboardBoxOk: Scalars['Boolean']['input'];
  deviceLabelOk: Scalars['Boolean']['input'];
  deviceTypeStickerOk: Scalars['Boolean']['input'];
  frontCasingOk: Scalars['Boolean']['input'];
  manualOk: Scalars['Boolean']['input'];
  pcbaOk: Scalars['Boolean']['input'];
  rj45Ok: Scalars['Boolean']['input'];
  sealOk: Scalars['Boolean']['input'];
  usbOk?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RefurbishDevicePayload = {
  __typename?: 'RefurbishDevicePayload';
  device: DeviceInfo;
};

/** Refurbish information for the device. Refurbishing happens after a device is returned. */
export type RefurbishInfo = {
  __typename?: 'RefurbishInfo';
  parts: DeviceRefurbishParts;
  refurbishId: Scalars['String']['output'];
  refurbishedAt: Scalars['Date']['output'];
};

export type RegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveChargingPermissionInput = {
  userIdentifier: UserIdentifierInput;
};

export type RemoveChargingPermissionPayload = {
  __typename?: 'RemoveChargingPermissionPayload';
  modifiedPermission: Permission;
  success: Scalars['Boolean']['output'];
  user: UserInfo;
};

export type RemoveControllableFromLocationInput = {
  controllableId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};

export type RemoveControllableFromLocationPayload = {
  __typename?: 'RemoveControllableFromLocationPayload';
  location: Location;
};

export type RemoveDevicePermissionsInput = {
  deviceIdentifiers: Array<DeviceIdentifierInput>;
  userIdentifier: UserIdentifierInput;
};

export type RemoveDevicePermissionsPayload = {
  __typename?: 'RemoveDevicePermissionsPayload';
  modifiedPermissions: Array<Permission>;
  success: Scalars['Boolean']['output'];
  user: UserInfo;
};

export type RemoveIntermediaryApiKeyInput = {
  id: Scalars['String']['input'];
};

export type RemoveIntermediaryUserInput = {
  externalId: Scalars['String']['input'];
};

export type RemoveIntermediaryUserPayload = {
  __typename?: 'RemoveIntermediaryUserPayload';
  user: UserInfo;
};

export type RemoveLocationInput = {
  locationId: Scalars['String']['input'];
};

export type RemoveLocationPayload = {
  __typename?: 'RemoveLocationPayload';
  location: Location;
};

export type RemoveNotificationChannelFromAlertSettingInput = {
  alertSettingId: Scalars['ID']['input'];
  notificationChannelType: NotificationChannelType;
};

export type RemoveNotificationChannelFromAlertSettingPayload = {
  __typename?: 'RemoveNotificationChannelFromAlertSettingPayload';
  success: Scalars['Boolean']['output'];
};

export type RemoveUserInput = {
  userIdentifier: UserIdentifierInput;
};

export type RemoveUserPayload = {
  __typename?: 'RemoveUserPayload';
  success: Scalars['Boolean']['output'];
  user: UserInfo;
};

export type Report = {
  __typename?: 'Report';
  /**
   * Active energy exported in the time period, in Wh
   *
   * Not available for the _current hour_
   */
  activeEnergyExported?: Maybe<Scalars['Float']['output']>;
  /**
   * Active energy imported in the time period, in Wh
   *
   * Not available for the _current hour_
   */
  activeEnergyImported?: Maybe<Scalars['Float']['output']>;
  /** Average of ActivePowerExport values in the time period, in W */
  averageActivePowerExport?: Maybe<Scalars['Float']['output']>;
  /** Average of ActivePowerImport values in the time period, in W */
  averageActivePowerImport?: Maybe<Scalars['Float']['output']>;
  /** Cumulative values of the active energy export in Wh at the start of the interval */
  cumulativeActiveEnergyExportedAtIntervalStart?: Maybe<Scalars['Float']['output']>;
  /** Cumulative values of the active energy import in Wh at the start of the interval */
  cumulativeActiveEnergyImportedAtIntervalStart?: Maybe<Scalars['Float']['output']>;
  /** Cumulative values of the reactive energy export in varh at the start of the interval */
  cumulativeReactiveEnergyExportedAtIntervalStart?: Maybe<Scalars['Float']['output']>;
  /** Cumulative values of the reactive energy import in varh at the start of the interval */
  cumulativeReactiveEnergyImportedAtIntervalStart?: Maybe<Scalars['Float']['output']>;
  /** Report start time, in UTC */
  from: Scalars['Date']['output'];
  /** Report end time, in UTC */
  to: Scalars['Date']['output'];
};

export type ReturnDeviceInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['String']['input'];
  hasBeenUsed: Scalars['Boolean']['input'];
};

export type ReturnDevicePayload = {
  __typename?: 'ReturnDevicePayload';
  device: DeviceInfo;
  success: Scalars['Boolean']['output'];
};

/** Return information */
export type ReturnInfo = {
  __typename?: 'ReturnInfo';
  comment?: Maybe<Scalars['String']['output']>;
  hasBeenUsed?: Maybe<Scalars['Boolean']['output']>;
  returnedAt?: Maybe<Scalars['Date']['output']>;
};

export type RevokeDeviceAccessInput = {
  deviceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type RushPricingDay = {
  __typename?: 'RushPricingDay';
  hours: HourRange;
  price: PriceSpecification;
};

/** The additional rush prices in a list, between two dates */
export type RushPricingPeriod = {
  __typename?: 'RushPricingPeriod';
  dateRange: DateRange;
  days: RushPricingWeek;
  holidaysIncluded: Scalars['Boolean']['output'];
};

export type RushPricingWeek = {
  __typename?: 'RushPricingWeek';
  friday?: Maybe<RushPricingDay>;
  monday?: Maybe<RushPricingDay>;
  saturday?: Maybe<RushPricingDay>;
  sunday?: Maybe<RushPricingDay>;
  thursday?: Maybe<RushPricingDay>;
  tuesday?: Maybe<RushPricingDay>;
  wednesday?: Maybe<RushPricingDay>;
};

export type Search = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  externalUserId?: InputMaybe<Scalars['String']['input']>;
  meterId?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

/** There are different prices for summer and winter, day and night */
export type SeasonalPrices = {
  __typename?: 'SeasonalPrices';
  summer: PricesForPartOfYear;
  winter: PricesForPartOfYear;
};

/** There are different prices for summer and winter, day and night */
export type SeasonalPricesBusiness = {
  __typename?: 'SeasonalPricesBusiness';
  summer: PricesForPartOfYearBusiness;
  winter: PricesForPartOfYearBusiness;
};

export type SeasonalPricesDemandTariff = {
  __typename?: 'SeasonalPricesDemandTariff';
  /**
   * Only used for a couple of companies, which will skip counting night/weekends
   * when finding the peak hour(s) of the month
   */
  highDemandHoursForWorkDays?: Maybe<HourRange>;
  peaksPerMonth: Scalars['Int']['output'];
  summer: SeasonalPricesDemandTariffSeason;
  winter: SeasonalPricesDemandTariffSeason;
};

export type SeasonalPricesDemandTariffSeason = {
  __typename?: 'SeasonalPricesDemandTariffSeason';
  months: MonthRange;
  pricePerKw: PriceSpecification;
};

/** There are different prices for summer and winter, but not day and night */
export type SeasonalPricesWithoutDayAndNight = {
  __typename?: 'SeasonalPricesWithoutDayAndNight';
  summer: PricesForPartOfYearWithoutDayAndNight;
  winter: PricesForPartOfYearWithoutDayAndNight;
};

/** There are different prices for summer and winter, but not day and night */
export type SeasonalPricesWithoutDayAndNightBusiness = {
  __typename?: 'SeasonalPricesWithoutDayAndNightBusiness';
  summer: PricesForPartOfYearWithoutDayAndNightBusiness;
  winter: PricesForPartOfYearWithoutDayAndNightBusiness;
};

export type SeasonalTieredDemandTariff = {
  __typename?: 'SeasonalTieredDemandTariff';
  /**
   * Only used for a couple of companies, which will skip counting night/weekends
   * when finding the peak hour(s) of the month
   */
  highDemandHoursForWorkDays?: Maybe<HourRange>;
  peaksPerMonth: Scalars['Int']['output'];
  summer: TieredSeason;
  winter: TieredSeason;
};

/**
 * Energy model were users can select type of energy model.
 *
 * Companies might have multiple types of energy models, and
 * let users select which model they would like use.
 */
export type SelectableEnergyModel = {
  __typename?: 'SelectableEnergyModel';
  constantPrice?: Maybe<ConstantPrice>;
  differentPricesDayAndNight?: Maybe<DifferentPricesDayAndNight>;
  differentPricesSeasonal?: Maybe<DifferentPricesSeasonal>;
  differentPricesSeasonalDayAndNight?: Maybe<DifferentPricesSeasonalDayAndNight>;
  type: EnergyModelType;
};

/**
 * Energy model were users can select type of energy model.
 *
 * Companies might have multiple types of energy models, and
 * let users select which model they would like use.
 */
export type SelectableEnergyModelBusiness = {
  __typename?: 'SelectableEnergyModelBusiness';
  constantPrice?: Maybe<ConstantPriceBusiness>;
  demandChargeStepWithSeasons?: Maybe<DemandChargeStepWithSeasonsBusiness>;
  differentPricesSeasonal?: Maybe<DifferentPricesSeasonalBusiness>;
  type: EnergyModelBusinessType;
};

export type SelectablePhasePrices = {
  __typename?: 'SelectablePhasePrices';
  voltage230: SelectablePhaseVoltagePrices;
  voltage400: SelectablePhaseVoltagePrices;
};

export type SelectablePhasePricesBusiness = {
  __typename?: 'SelectablePhasePricesBusiness';
  voltage230: SelectablePhaseVoltagePricesBusiness;
  voltage400: SelectablePhaseVoltagePricesBusiness;
};

export type SelectablePhaseVoltagePrices = {
  __typename?: 'SelectablePhaseVoltagePrices';
  currentRangesWithSelectable: Array<CurrentRangeWithSelectable>;
};

export type SelectablePhaseVoltagePricesBusiness = {
  __typename?: 'SelectablePhaseVoltagePricesBusiness';
  currentRangesWithSelectable: Array<CurrentRangeWithSelectableBusiness>;
  energyModelAboveCurrentRanges?: Maybe<SelectableEnergyModelBusiness>;
};

export type SelectableSeasonal = {
  __typename?: 'SelectableSeasonal';
  regular: PricesAndTaxes;
  seasonal: EnergyModelSeasonalConstant;
};

export enum SentAlertAlertType {
  EstimatedHourlyActiveEnergyLimitWarning = 'ESTIMATED_HOURLY_ACTIVE_ENERGY_LIMIT_WARNING',
  HourlyConsumptionLimitEstimationWarning = 'HOURLY_CONSUMPTION_LIMIT_ESTIMATION_WARNING',
  PriceWarning = 'PRICE_WARNING'
}

export type SessionInfo = {
  __typename?: 'SessionInfo';
  accessToken: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type SessionInfoWithoutAccessToken = {
  __typename?: 'SessionInfoWithoutAccessToken';
  startOfSecret: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type SetCoordinatesForLocationInput = {
  coordinates: LatLngInput;
  locationId: Scalars['String']['input'];
};

export type SetCoordinatesForLocationPayload = {
  __typename?: 'SetCoordinatesForLocationPayload';
  location: Location;
};

export type SetDeviceActivationStatusInput = {
  activationStatus: ActivationStatus;
  deviceIdentifier: DeviceIdentifierInput;
};

export type SetDeviceActivationStatusPayload = {
  __typename?: 'SetDeviceActivationStatusPayload';
  device: DeviceInfo;
  success: Scalars['Boolean']['output'];
};

export type SetDeviceForLocationInput = {
  deviceIdentifier: DeviceQueryIdentifier;
  locationId: Scalars['String']['input'];
};

export type SetDeviceForLocationPayload = {
  __typename?: 'SetDeviceForLocationPayload';
  location: Location;
};

export type SetEnergyConsumptionLimitForLocationInput = {
  limit: Scalars['Int']['input'];
  locationId: Scalars['String']['input'];
};

export type SetEnergyConsumptionLimitForLocationPayload = {
  __typename?: 'SetEnergyConsumptionLimitForLocationPayload';
  location: Location;
};

export type SetIntermediaryWebhookSettingInput = {
  intermediaryId?: InputMaybe<Scalars['String']['input']>;
  secret: Scalars['String']['input'];
};

export type SetIntermediaryWebhookSettingPayload = {
  __typename?: 'SetIntermediaryWebhookSettingPayload';
  webhookSetting: IntermediaryWebhookSetting;
};

export type SetNameForLocationInput = {
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type SetNameForLocationPayload = {
  __typename?: 'SetNameForLocationPayload';
  location: Location;
};

export type ShipDeviceIdentifierInput = {
  claimId?: InputMaybe<Scalars['ClaimId']['input']>;
  deviceId?: InputMaybe<Scalars['DeviceId']['input']>;
};

export type ShipOrderInput = {
  deviceIdentifier: ShipDeviceIdentifierInput;
  orderId: Scalars['String']['input'];
  trackingLink: Scalars['String']['input'];
};

export type ShipToUserInput = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  externalUserId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalAddress: PostalAddressInput;
  trackingLink?: InputMaybe<Scalars['String']['input']>;
};

/** User information for tracking shipment and activation */
export type ShippedToUserInfo = {
  __typename?: 'ShippedToUserInfo';
  emailAddress?: Maybe<Scalars['String']['output']>;
  externalUserId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalAddress: PostalAddress;
  trackingLink?: Maybe<Scalars['String']['output']>;
};

export type SmartChargingConsideration = {
  __typename?: 'SmartChargingConsideration';
  hasTimeEstimate: Scalars['Boolean']['output'];
  isCharging: Scalars['Boolean']['output'];
  isPluggedIn: Scalars['Boolean']['output'];
  recentlyAtChargingLocation: Scalars['Boolean']['output'];
};

export type SmartChargingPlan = {
  __typename?: 'SmartChargingPlan';
  endedAt?: Maybe<Scalars['String']['output']>;
  estimatedFinishAt: Scalars['String']['output'];
  nonSmartCost: Scalars['Float']['output'];
  smartCost?: Maybe<Scalars['Float']['output']>;
  startAt?: Maybe<Scalars['String']['output']>;
  startConfirmedAt?: Maybe<Scalars['String']['output']>;
  stopConfirmedAt?: Maybe<Scalars['String']['output']>;
};

export enum SmartChargingPlanningStatusType {
  PlanEndedDeadlineChanged = 'PLAN_ENDED_DEADLINE_CHANGED',
  PlanEndedDisabled = 'PLAN_ENDED_DISABLED',
  PlanEndedFailed = 'PLAN_ENDED_FAILED',
  PlanEndedFinished = 'PLAN_ENDED_FINISHED',
  PlanEndedUnplugged = 'PLAN_ENDED_UNPLUGGED',
  PlanExecutingChargeInterrupted = 'PLAN_EXECUTING_CHARGE_INTERRUPTED',
  PlanExecutingOverridden = 'PLAN_EXECUTING_OVERRIDDEN',
  PlanExecutingStarted = 'PLAN_EXECUTING_STARTED',
  PlanExecutingStarting = 'PLAN_EXECUTING_STARTING',
  PlanExecutingStartFailed = 'PLAN_EXECUTING_START_FAILED',
  PlanExecutingStopped = 'PLAN_EXECUTING_STOPPED',
  PlanExecutingStoppedAwaitingPrices = 'PLAN_EXECUTING_STOPPED_AWAITING_PRICES',
  PlanExecutingStopping = 'PLAN_EXECUTING_STOPPING',
  PlanExecutingStopFailed = 'PLAN_EXECUTING_STOP_FAILED'
}

export type SmartChargingPolicy = {
  __typename?: 'SmartChargingPolicy';
  deadlineInUtcTime: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
};

export enum SmartChargingStatusType {
  Considering = 'CONSIDERING',
  Disabled = 'DISABLED',
  FullyCharged = 'FULLY_CHARGED',
  Planned = 'PLANNED'
}

export type StartOperationalCheckInput = {
  deviceIdentifier: DeviceIdentifierInput;
};

export type StartOperationalCheckPayload = {
  __typename?: 'StartOperationalCheckPayload';
  device: DeviceInfo;
  success: Scalars['Boolean']['output'];
};

export type SubscriptionBilling = {
  __typename?: 'SubscriptionBilling';
  subscriptionType: SubscriptionType;
};

export type SubscriptionInput = {
  subscriptionType?: InputMaybe<SubscriptionType>;
};

export enum SubscriptionType {
  Business = 'BUSINESS',
  Personal = 'PERSONAL',
  Pilot = 'PILOT'
}

export type TestWebhookSettingInput = {
  callbackUrl: Scalars['String']['input'];
  intermediaryId?: InputMaybe<Scalars['String']['input']>;
};

export type TestWebhookSettingPayload = {
  __typename?: 'TestWebhookSettingPayload';
  success: Scalars['Boolean']['output'];
};

export type TieredDemandTariff = {
  __typename?: 'TieredDemandTariff';
  demandTariffTiers: Array<DemandTariffTier>;
  /**
   * Only used for a couple of companies, which will skip counting night/weekends
   * when finding the peak hour(s) of the month
   */
  highDemandHoursForWorkDays?: Maybe<HourRange>;
  peaksPerMonth: Scalars['Int']['output'];
  priceAboveDemandTariffTiers: PriceSpecification;
};

export type TieredSeason = {
  __typename?: 'TieredSeason';
  demandTariffTiers: Array<DemandTariffTier>;
  months: MonthRange;
  priceAboveDemandTariffTiers: PriceSpecification;
};

/** Time zones, as reported by the _Internet Assigned Numbers Authority_ (IANA) database, but using an underscore for the forward slash. */
export enum Timezone {
  EuropeOslo = 'EUROPE_OSLO',
  Utc = 'UTC'
}

/**
 * Input object for updating charge settings.
 * - `defaultStartBatteryLevel` can be set as a default battery level for the beginning of a session, if we cannot get the SoC from the vehicle this value will be used.
 * - `departureTimes` is a list of departure times for each day of the week.
 * - `desiredBatteryLevel` is the battery level at which the car should be charged at the departure time.
 * - `directChargingBatteryLevel` is the battery level at which the car should start charging immediately.
 * - `enableSmartChargingAt` is the date at which smart charging should be enabled.
 * - `isSmartChargingEnabled` is whether smart charging is enabled.
 * - `isSolarChargingEnabled` is whether solar charging is enabled.
 * - `maxAllowedTargetSoC` is the maximum allowed target state of charge.
 * - `timeZone` is the time zone of the user.
 * - `vehicleId` is the id of the vehicle.
 */
export type UpdateChargeSettingsInput = {
  defaultStartBatteryLevel?: InputMaybe<Scalars['Float']['input']>;
  departureTimes: DepartureTimesInput;
  desiredBatteryLevel: Scalars['Float']['input'];
  directChargingBatteryLevel: Scalars['Float']['input'];
  enableSmartChargingAt?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['String']['input'];
  isSmartChargingEnabled: Scalars['Boolean']['input'];
  isSolarChargingEnabled: Scalars['Boolean']['input'];
  maxAllowedTargetSoC: Scalars['Float']['input'];
  timeZone: Timezone;
  vehicleId: Scalars['String']['input'];
};

/** Response object when updating charge settings. */
export type UpdateChargeSettingsPayload = {
  __typename?: 'UpdateChargeSettingsPayload';
  chargeSettings: ChargeSettings;
};

export type UpdateChargingLocationInput = {
  id: Scalars['ID']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  name: Scalars['String']['input'];
};

export type UpdateChargingLocationPayload = {
  __typename?: 'UpdateChargingLocationPayload';
  chargingLocation: ChargingLocation;
};

export type UpdateEstimatedHourlyActiveEnergyLimitWarningAlertSettingInput = {
  alertSettingId: Scalars['ID']['input'];
  limitInWattHours: Scalars['Int']['input'];
};

export type UpdateEstimatedHourlyActiveEnergyLimitWarningAlertSettingPayload = {
  __typename?: 'UpdateEstimatedHourlyActiveEnergyLimitWarningAlertSettingPayload';
  alertSetting: EstimatedHourlyActiveEnergyLimitWarningAlertSetting;
};

export type UpdateHourlyConsumptionLimitEstimationWarningAlertSettingInput = {
  alertSettingId: Scalars['ID']['input'];
  limitInWatts: Scalars['Int']['input'];
};

export type UpdateHourlyConsumptionLimitEstimationWarningAlertSettingPayload = {
  __typename?: 'UpdateHourlyConsumptionLimitEstimationWarningAlertSettingPayload';
  alertSetting: HourlyConsumptionLimitEstimationWarningAlertSetting;
};

export type UpdateJedlixChargingLocationInput = {
  address: JedlixAddressInput;
  chargingLocationId: Scalars['String']['input'];
  coordinates: LatLngInput;
};

export type UpdateSmartChargingPolicyInput = {
  /**
   * Time for when the charging should be finished by.
   * hours:minutes, e.g. 08:00 or 23:59, in UTC time
   */
  deadlineInUtcTime: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  vehicleId: Scalars['String']['input'];
};

export type UpdateSmartChargingPolicyPayload = {
  __typename?: 'UpdateSmartChargingPolicyPayload';
  smartChargingPolicy: SmartChargingPolicy;
};

export type User = {
  __typename?: 'User';
  id: Scalars['String']['output'];
  verifiedIdentities?: Maybe<Array<Identity>>;
};

export type UserIdentifier = ExternalUserIdentifier;

export type UserIdentifierInput = {
  externalUser?: InputMaybe<ExternalUserIdentifierInput>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  alertSettings?: Maybe<Array<AlertSetting>>;
  chargingLocations?: Maybe<Array<ChargingLocation>>;
  id: Scalars['ID']['output'];
  intermediaries?: Maybe<Array<IntermediaryInfo>>;
  linkedIntegrationVendors?: Maybe<Array<IntegrationVendorInfo>>;
  sessions?: Maybe<Array<SessionInfoWithoutAccessToken>>;
  userIdentifier?: Maybe<UserIdentifier>;
  verifiedEmail?: Maybe<Scalars['String']['output']>;
  verifiedIdentities?: Maybe<Array<Identity>>;
};


export type UserInfoIntermediariesArgs = {
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UserInput = {
  userIdentifier: UserIdentifierInput;
};

export type UserNotAuthenticatedError = CustomError & {
  __typename?: 'UserNotAuthenticatedError';
  message: Scalars['String']['output'];
  type: ErrorType;
};

export type UserNotPermittedError = CustomError & {
  __typename?: 'UserNotPermittedError';
  entityId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  resourceId?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  type: ErrorType;
};

export type UserPayload = {
  __typename?: 'UserPayload';
  user: UserInfo;
};

export type VehicleCapabilities = {
  __typename?: 'VehicleCapabilities';
  charge: Scalars['Boolean']['output'];
  chargeState: Scalars['Boolean']['output'];
  desiredStateOfCharge: Scalars['Boolean']['output'];
  geoLocation: Scalars['Boolean']['output'];
  pullTelemetry: Scalars['Boolean']['output'];
  startStopCharging: Scalars['Boolean']['output'];
  stateOfCharge: Scalars['Boolean']['output'];
};

export enum VehicleChargingStatus {
  Charging = 'CHARGING',
  Complete = 'COMPLETE',
  Disconnected = 'DISCONNECTED',
  Stopped = 'STOPPED',
  Unknown = 'UNKNOWN'
}

export type VehicleInfo = {
  __typename?: 'VehicleInfo';
  batteryCapacity: Scalars['Float']['output'];
  brand: JedlixBrand;
  model: Scalars['String']['output'];
  range: Scalars['Float']['output'];
  version: Scalars['String']['output'];
};

export type VehicleSmartChargingStatusInput = {
  vehicleId: Scalars['String']['input'];
};

export type VehicleSmartChargingStatusPayload = ConsideringSmartChargingStatus | DisabledSmartChargingStatus | FullyChargedSmartChargingStatus | PlannedSmartChargingStatus;

export enum Vendor {
  Adax = 'ADAX',
  Mill = 'MILL'
}

/**
 * Capacity model used by Fjellnett/Eidefoss
 *
 * Computation steps, according to <https://www.fjellnett.no/privatkunder/category1153.html>:
 *
 * - Fetch consumption data for each hour for the previous twelve months.
 * - Multiply the consumption for each hour with the corresponding month weights.
 * - Find the peak value of every week.
 * - Pick the highest (5) `weekPeaksPerYear` and compute the average for these (with two decimals).
 * - Multiply by `pricePerAverageKwh`.
 * - Add `baseFeePerYear`.
 * - Divide by 12.
 */
export type WeightedYearlyRollingPeaksInDifferentWeeks = {
  __typename?: 'WeightedYearlyRollingPeaksInDifferentWeeks';
  baseFeePerYear: PriceSpecification;
  monthWeights: MonthWeights;
  pricePerKwhForAverageOfPeaks: PriceSpecification;
  type: CapacityModelType;
  weekPeaksPerYear: Scalars['Int']['output'];
};

/**
 * Capacity model used by Fjellnett/Eidefoss
 *
 * Computation steps, according to <https://www.fjellnett.no/privatkunder/category1153.html>:
 *
 * - Fetch consumption data for each hour for the previous twelve months.
 * - Multiply the consumption for each hour with the corresponding month weights.
 * - Find the peak value of every week.
 * - Pick the highest (5) `weekPeaksPerYear` and compute the average for these (with two decimals).
 * - Multiply by `pricePerAverageKwh`.
 * - Add `baseFeePerYear`.
 * - Divide by 12.
 */
export type WeightedYearlyRollingPeaksInDifferentWeeksBusiness = {
  __typename?: 'WeightedYearlyRollingPeaksInDifferentWeeksBusiness';
  baseFeePerYear: PriceSpecification;
  monthWeights: MonthWeights;
  pricePerKwhForAverageOfPeaks: PriceSpecification;
  type: CapacityModelBusinessType;
  weekPeaksPerYear: Scalars['Int']['output'];
  yearlyEnergyFund: PriceSpecification;
};

export type ZaptecClaimInstallationInput = {
  installationId: Scalars['String']['input'];
};

export type ZaptecClaimInstallationPayload = {
  __typename?: 'ZaptecClaimInstallationPayload';
  success: Scalars['Boolean']['output'];
};

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginPayload', session: { __typename?: 'SessionInfo', accessToken: string }, user: { __typename?: 'UserInfo', id: string, verifiedEmail?: string | null } } };

export type RegisterMutationVariables = Exact<{
  input: RegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register?: boolean | null };

export type SendResetPasswordEmailMutationVariables = Exact<{
  input: EmailActionInput;
}>;


export type SendResetPasswordEmailMutation = { __typename?: 'Mutation', sendResetPasswordEmail?: boolean | null };

export type SendEmailVerificationEmailMutationVariables = Exact<{
  input: EmailActionInput;
}>;


export type SendEmailVerificationEmailMutation = { __typename?: 'Mutation', sendEmailVerificationEmail?: boolean | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'UserInfo', id: string, verifiedEmail?: string | null } };

export type MyIntermediaryScopesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyIntermediaryScopesQuery = { __typename?: 'Query', me: { __typename?: 'UserInfo', id: string, intermediaries?: Array<{ __typename?: 'IntermediaryInfo', id: string, permissionScopes?: Array<string> | null }> | null } };

export type DashboardIntermediaryFragment = { __typename?: 'IntermediaryInfo', permissionScopes?: Array<string> | null } & { ' $fragmentName'?: 'DashboardIntermediaryFragment' };

export type MyIntermediaryDevicesSearchQueryVariables = Exact<{
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  search?: InputMaybe<Search>;
}>;


export type MyIntermediaryDevicesSearchQuery = { __typename?: 'Query', me: { __typename?: 'UserInfo', id: string, intermediaries?: Array<{ __typename?: 'IntermediaryInfo', id: string, devices?: Array<(
        { __typename?: 'DeviceInfo' }
        & { ' $fragmentRefs'?: { 'DashboardListDeviceFragment': DashboardListDeviceFragment } }
      )> | null }> | null } };

export type ModalDeviceQueryVariables = Exact<{
  input: DeviceQueryInput;
}>;


export type ModalDeviceQuery = { __typename?: 'Query', device: { __typename?: 'DeviceQueryPayload', device: (
      { __typename?: 'DeviceInfo' }
      & { ' $fragmentRefs'?: { 'ModalDeviceFragment': ModalDeviceFragment } }
    ) } };

export type MyIntermediaryDeviceStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyIntermediaryDeviceStatsQuery = { __typename?: 'Query', me: { __typename?: 'UserInfo', id: string, intermediaries?: Array<{ __typename?: 'IntermediaryInfo', id: string, deviceStats?: { __typename?: 'DeviceStats', total: number, returnedDevices: number, devicesAtCustomer: number, devicesActivated: number, devicesDeactivated: number, devicesActivationReady: number } | null }> | null } };

export type DashboardListDeviceFragment = { __typename?: 'DeviceInfo', deviceId: string, intermediaryId?: string | null, deviceName?: string | null, shippedAt?: string | null, type: string, activation?: { __typename?: 'Activation', status: ActivationStatus, updatedAt: any } | null, diagnostic?: { __typename?: 'DiagnosticInfo', lastMessageAt?: any | null, lastPingAt?: any | null, signalStrength?: number | null } | null, ownedBy?: { __typename?: 'OwnedByUserInfo', firstName: string, lastName: string, externalUserId?: string | null } | null, recentMeter?: { __typename?: 'RecentMeter', meterId: any, producer: MeterProducer } | null, returnInfo?: { __typename?: 'ReturnInfo', hasBeenUsed?: boolean | null, returnedAt?: any | null } | null, updateStatus?: { __typename?: 'DeviceUpdateStatus', finishedAt?: any | null, startedAt: any } | null } & { ' $fragmentName'?: 'DashboardListDeviceFragment' };

export type ModalDeviceFragment = { __typename?: 'DeviceInfo', deviceId: string, intermediaryId?: string | null, deviceName?: string | null, shippedAt?: string | null, type: string, activation?: { __typename?: 'Activation', status: ActivationStatus, updatedAt: any } | null, diagnostic?: { __typename?: 'DiagnosticInfo', lastMessageAt?: any | null, lastPingAt?: any | null, publishInterval?: number | null, signalStrength?: number | null, firmwareVersion?: number | null } | null, ownedBy?: { __typename?: 'OwnedByUserInfo', firstName: string, lastName: string, externalUserId?: string | null, emailAddress?: string | null, phoneNumber?: string | null, postalAddress?: { __typename?: 'OptionalFieldsPostalAddress', streetAddress?: string | null, postcode?: string | null, country?: PostcodeCountry | null } | null } | null, recentMeter?: { __typename?: 'RecentMeter', meterId: any, producer: MeterProducer } | null, returnInfo?: { __typename?: 'ReturnInfo', hasBeenUsed?: boolean | null, returnedAt?: any | null } | null, updateStatus?: { __typename?: 'DeviceUpdateStatus', finishedAt?: any | null, version: number, progressPercent: number, startedAt: any, updatedAt: any } | null, shippedTo?: { __typename?: 'ShippedToUserInfo', firstName: string, lastName: string, emailAddress?: string | null, phoneNumber?: string | null, externalUserId?: string | null, trackingLink?: string | null, postalAddress: { __typename?: 'PostalAddress', streetAddress: string, postcode: string, country: PostcodeCountry } } | null, subscription?: { __typename?: 'SubscriptionBilling', subscriptionType: SubscriptionType } | null } & { ' $fragmentName'?: 'ModalDeviceFragment' };

export type UpdateDeviceNameMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
}>;


export type UpdateDeviceNameMutation = { __typename?: 'Mutation', updateDeviceName?: { __typename?: 'DeviceInfo', deviceId: string, deviceName?: string | null } | null };

export type DeleteDeviceNameMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;


export type DeleteDeviceNameMutation = { __typename?: 'Mutation', deleteDeviceName?: { __typename?: 'DeviceInfo', deviceId: string } | null };

export type UpdateDeviceOwnerMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
  deviceOwner: DeviceOwnerInput;
}>;


export type UpdateDeviceOwnerMutation = { __typename?: 'Mutation', updateDeviceOwner?: { __typename?: 'DeviceInfo', deviceId: string, ownedBy?: { __typename?: 'OwnedByUserInfo', firstName: string, lastName: string, emailAddress?: string | null, phoneNumber?: string | null, externalUserId?: string | null, postalAddress?: { __typename?: 'OptionalFieldsPostalAddress', streetAddress?: string | null, postcode?: string | null, country?: PostcodeCountry | null } | null } | null } | null };

export type SetDeviceActivationStatusMutationVariables = Exact<{
  deviceIdentifier: DeviceIdentifierInput;
  activationStatus: ActivationStatus;
}>;


export type SetDeviceActivationStatusMutation = { __typename?: 'Mutation', setDeviceActivationStatus: { __typename?: 'SetDeviceActivationStatusPayload', success: boolean, device: { __typename?: 'DeviceInfo', deviceId: string, activation?: { __typename?: 'Activation', status: ActivationStatus } | null } } };

export type DrawerMenuIntermediaryFragment = { __typename?: 'IntermediaryInfo', id: string } & { ' $fragmentName'?: 'DrawerMenuIntermediaryFragment' };

export const DashboardIntermediaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardIntermediary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntermediaryInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissionScopes"}}]}}]} as unknown as DocumentNode<DashboardIntermediaryFragment, unknown>;
export const DashboardListDeviceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardListDevice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"activation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diagnostic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastMessageAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastPingAt"}},{"kind":"Field","name":{"kind":"Name","value":"signalStrength"}}]}},{"kind":"Field","name":{"kind":"Name","value":"intermediaryId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceName"}},{"kind":"Field","name":{"kind":"Name","value":"ownedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"externalUserId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentMeter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterId"}},{"kind":"Field","name":{"kind":"Name","value":"producer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"returnInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasBeenUsed"}},{"kind":"Field","name":{"kind":"Name","value":"returnedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updateStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}}]}}]}}]} as unknown as DocumentNode<DashboardListDeviceFragment, unknown>;
export const ModalDeviceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModalDevice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"activation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diagnostic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastMessageAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastPingAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishInterval"}},{"kind":"Field","name":{"kind":"Name","value":"signalStrength"}},{"kind":"Field","name":{"kind":"Name","value":"firmwareVersion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"intermediaryId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceName"}},{"kind":"Field","name":{"kind":"Name","value":"ownedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"externalUserId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentMeter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterId"}},{"kind":"Field","name":{"kind":"Name","value":"producer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"returnInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasBeenUsed"}},{"kind":"Field","name":{"kind":"Name","value":"returnedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updateStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"progressPercent"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"externalUserId"}},{"kind":"Field","name":{"kind":"Name","value":"postalAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippedTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"externalUserId"}},{"kind":"Field","name":{"kind":"Name","value":"trackingLink"}},{"kind":"Field","name":{"kind":"Name","value":"postalAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionType"}}]}}]}}]} as unknown as DocumentNode<ModalDeviceFragment, unknown>;
export const DrawerMenuIntermediaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DrawerMenuIntermediary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntermediaryInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<DrawerMenuIntermediaryFragment, unknown>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedEmail"}}]}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Register"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegisterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<RegisterMutation, RegisterMutationVariables>;
export const SendResetPasswordEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendResetPasswordEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailActionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendResetPasswordEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>;
export const SendEmailVerificationEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendEmailVerificationEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailActionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendEmailVerificationEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SendEmailVerificationEmailMutation, SendEmailVerificationEmailMutationVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedEmail"}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const MyIntermediaryScopesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyIntermediaryScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"intermediaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permissionScopes"}}]}}]}}]}}]} as unknown as DocumentNode<MyIntermediaryScopesQuery, MyIntermediaryScopesQueryVariables>;
export const MyIntermediaryDevicesSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyIntermediaryDevicesSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"intermediaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardListDevice"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardListDevice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"activation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diagnostic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastMessageAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastPingAt"}},{"kind":"Field","name":{"kind":"Name","value":"signalStrength"}}]}},{"kind":"Field","name":{"kind":"Name","value":"intermediaryId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceName"}},{"kind":"Field","name":{"kind":"Name","value":"ownedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"externalUserId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentMeter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterId"}},{"kind":"Field","name":{"kind":"Name","value":"producer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"returnInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasBeenUsed"}},{"kind":"Field","name":{"kind":"Name","value":"returnedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updateStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}}]}}]}}]} as unknown as DocumentNode<MyIntermediaryDevicesSearchQuery, MyIntermediaryDevicesSearchQueryVariables>;
export const ModalDeviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ModalDevice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"device"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModalDevice"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModalDevice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"activation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diagnostic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastMessageAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastPingAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishInterval"}},{"kind":"Field","name":{"kind":"Name","value":"signalStrength"}},{"kind":"Field","name":{"kind":"Name","value":"firmwareVersion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"intermediaryId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceName"}},{"kind":"Field","name":{"kind":"Name","value":"ownedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"externalUserId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentMeter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterId"}},{"kind":"Field","name":{"kind":"Name","value":"producer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"returnInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasBeenUsed"}},{"kind":"Field","name":{"kind":"Name","value":"returnedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updateStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"progressPercent"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"externalUserId"}},{"kind":"Field","name":{"kind":"Name","value":"postalAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippedTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"externalUserId"}},{"kind":"Field","name":{"kind":"Name","value":"trackingLink"}},{"kind":"Field","name":{"kind":"Name","value":"postalAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionType"}}]}}]}}]} as unknown as DocumentNode<ModalDeviceQuery, ModalDeviceQueryVariables>;
export const MyIntermediaryDeviceStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyIntermediaryDeviceStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"intermediaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deviceStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"returnedDevices"}},{"kind":"Field","name":{"kind":"Name","value":"devicesAtCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"devicesActivated"}},{"kind":"Field","name":{"kind":"Name","value":"devicesDeactivated"}},{"kind":"Field","name":{"kind":"Name","value":"devicesActivationReady"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MyIntermediaryDeviceStatsQuery, MyIntermediaryDeviceStatsQueryVariables>;
export const UpdateDeviceNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDeviceName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDeviceName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"deviceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceName"}}]}}]}}]} as unknown as DocumentNode<UpdateDeviceNameMutation, UpdateDeviceNameMutationVariables>;
export const DeleteDeviceNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDeviceName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDeviceName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}}]}}]}}]} as unknown as DocumentNode<DeleteDeviceNameMutation, DeleteDeviceNameMutationVariables>;
export const UpdateDeviceOwnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDeviceOwner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceOwner"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceOwnerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDeviceOwner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"deviceOwner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceOwner"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"externalUserId"}},{"kind":"Field","name":{"kind":"Name","value":"postalAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDeviceOwnerMutation, UpdateDeviceOwnerMutationVariables>;
export const SetDeviceActivationStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetDeviceActivationStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceIdentifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceIdentifierInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activationStatus"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivationStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setDeviceActivationStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deviceIdentifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceIdentifier"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"activationStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activationStatus"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SetDeviceActivationStatusMutation, SetDeviceActivationStatusMutationVariables>;